import React, { useEffect, useState, useMemo } from "react";
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, ComposedChart, Area, Brush, } from "recharts";
import { Box, Typography, Button, Popover, Divider, Paper, List, ListItem, ListItemText, Menu, MenuItem } from "@mui/material";
import moment from "moment";
import {
    buildingDataAPI,
    solarDataAPI,
    gridWithoutEcosDataAPI,
    gridwithEcosDataAPI,
    batteryPowerDataAPI,
    BatterySOCDataAPI,
} from "../api/meter";
import {
    sm_loadDataAPI,
    sm_solarDataAPI,
    sm_gridDataAPI,
    nema_unbalanceSolarAPI,
    nema_unbalanceGridAPI,
    nema_unbalanceGrid_currentAPI,
    nema_unbalanceSolar_currentAPI,
    nema_unbalanceSolar_kwAPI,
    nema_unbalanceGrid_kwAPI,
    harmonics_voltage,
    harmonics_current,
    harmonics_current_solar,
    harmonics_voltage_solar,

} from "../api/smartmeter";
import { LoadForecastDataAPI, SolarForecastDataAPI } from "../api/forecast";
import { getUserDetails, updateGraphPreferences } from "../api/user";
import { useDarkMode } from "../components/DarkModeContext";
import colors from "../colour";
import LoadingOverlay from "./loadingOverlay";
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import { Tooltip as MuiTooltip } from '@mui/material';
import { UseAccessLevel } from "../AccessLevelContext";
import { fetchSiteDetails } from './../api/plant';
import axios from "axios";
import {
    sm_gridDatayesterday, sm_gridDatasamedaylastweek, sm_gridDatalastweekavg, sm_gridDatalastmonthavg, sm_gridDatalastyearavg, missing_percentage_solar,
    //  accum_max_kw, accum_max_kw_solar,
    sm_solarDatayesterday, sm_solarDatasamedaylastweek, sm_solarDatalastweekavg, sm_solarDatalastmonthavg, sm_solarDatalastyearavg, missing_percentage_grid
} from "../api/smartmeter";

const GraphSection = ({ siteId, selectedDate, timeInterval, userType }) => {
    const { darkMode } = useDarkMode();
    const [BuildingLoad, setBuildingLoad] = useState([]);
    const [solarData, setSolarData] = useState([]);
    const [gridWithoutEcosData, setGridWithoutEcosData] = useState([]);
    const [gridWithEcosData, setGridWithEcosData] = useState([]);
    const [batteryPowerData, setBatteryPowerData] = useState([]);
    const [batterySOCData, setBatterySOCData] = useState([]);
    const [loadForecastData, setLoadForecastData] = useState([]);
    const [solarForecastData, setSolarForecastData] = useState([]);
    const [activeSeries, setActiveSeries] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [smloadData, setsmloadData] = useState([]);
    const [smsolarData, setsmsolarData] = useState([]);
    const [smgridData, setsmgridData] = useState([]);
    const [currentSMGrid, setCurrentSMGrid] = useState([]);
    const [currentSMSolar, setCurrentSMSolar] = useState([]);
    const [nemaUnbalanceGrid, setNemaUnbalanceGrid] = useState([]);
    const [nemaUnbalanceSolar, setNemaUnbalanceSolar] = useState([]);
    const [nemaUnbalanceGridCurrent, setNemaUnbalanceGridCurrent] = useState([]);
    const [nemaUnbalanceSolarCurrent, setNemaUnbalanceSolarCurrent] = useState([]);
    const [nemaUnbalanceGridPower, setNemaUnbalanceGridPower] = useState([]);
    const [nemaUnbalanceSolarPower, setNemaUnbalanceSolarPower] = useState([]);
    const { accessLevel } = UseAccessLevel();
    const [userData, setuserData] = useState({});
    const [comparisonType, setComparisonType] = useState(null);
    const [comparisonGridData, setComparisonGridData] = useState([]);
    const [comparisonAccumMax, setComparisonAccumMax] = useState(null);
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const [solarComparisonType, setSolarComparisonType] = useState(null);
    const [comparisonSolarData, setComparisonSolarData] = useState([]);
    const [solarAnchorEl, setSolarAnchorEl] = useState(null);
    const solarOpen = Boolean(solarAnchorEl);
    const [missingPercentages, setMissingPercentages] = useState({});
    const [missingPercentagesSolar, setMissingPercentagesSolar] = useState({});
    const [solarComparisonAccumMax, setSolarComparisonAccumMax] = useState(null);
    const [harmonicsCurrent, setHarmonicsCurrent] = useState([]);
    const [harmonicsVoltage, setHarmonicsVoltage] = useState([]);
    const [harmonicsCurrent_solar, setHarmonicsCurrent_solar] = useState([]);
    const [harmonicsVoltage_solar, setHarmonicsVoltage_solar] = useState([]);
    const [graphToggles, setGraphToggles] = useState({});

    useEffect(() => {
        const fetchUserInfo = async () => {
            const data = await getUserDetails();
            setGraphToggles(data.graph_prefs);
        };
        fetchUserInfo();
    }, []);

    // Interval Setting
    const TIME_INTERVALS = useMemo(
        () => ({
            "5m": { value: 300, label: "5 Minute", interval: "5m" },
            "15m": { value: 900, label: "15 Minute", interval: "15m" },
            "30m": { value: 1800, label: "30 Minutes", interval: "30m" },
            "1h": { value: 3600, label: "1 Hour", interval: "1h" },
        }),
        []
    );
    const TIME_INTERVAL = useMemo(
        () => ({
            "5m": { value: 300, label: "5 Minute", interval: "5m" },
        }),
        []
    );

    //fetch data evry 5 minutes
    useEffect(() => {
        if (!siteId || !selectedDate || !timeInterval) return;

        const formattedDate = moment(selectedDate).format("YYYY-MM-DD");
        const selectedValue = TIME_INTERVALS[timeInterval].value;
        const currenttime = moment().format("YYYY-MM-DD");
        const selectedtime = TIME_INTERVAL[timeInterval]?.value ?? 300;

        const fetchData = async () => {
            setIsLoading(true);
            try {
                if (userType === 1) {
                    const [sm_loadData, sm_solarData, sm_gridData, sm_grid, sm_solar, userInfoResp] = await Promise.all([
                        sm_loadDataAPI(siteId, formattedDate, selectedValue),
                        sm_solarDataAPI(siteId, formattedDate, selectedValue),
                        sm_gridDataAPI(siteId, formattedDate, selectedValue),
                        sm_gridDataAPI(siteId, currenttime, selectedtime),
                        sm_solarDataAPI(siteId, currenttime, selectedtime),
                        fetchSiteDetails(siteId),
                    ]);

                    setsmloadData(sm_loadData?.data ?? []);
                    setsmsolarData(sm_solarData?.data ?? []);
                    setsmgridData(sm_gridData?.data ?? []);
                    setCurrentSMGrid(sm_grid?.data ?? []);
                    setCurrentSMSolar(sm_solar?.data ?? []);
                    setuserData(userInfoResp);

                } else {
                    const [building, solar, gridWOut, gridW, batteryPower, batterySOC, loadForecast, solarForecast, userInfoResp] = await Promise.all([
                        buildingDataAPI(siteId, formattedDate, selectedValue),
                        solarDataAPI(siteId, formattedDate, selectedValue),
                        gridWithoutEcosDataAPI(siteId, formattedDate, selectedValue),
                        gridwithEcosDataAPI(siteId, formattedDate, selectedValue),
                        batteryPowerDataAPI(siteId, formattedDate, selectedValue),
                        BatterySOCDataAPI(siteId, formattedDate, selectedValue),
                        LoadForecastDataAPI(siteId, formattedDate, selectedValue),
                        SolarForecastDataAPI(siteId, formattedDate, selectedValue),
                        fetchSiteDetails(siteId),
                    ]);

                    setBuildingLoad(building?.data ?? []);
                    setSolarData(solar?.data ?? []);
                    setGridWithoutEcosData(gridWOut?.data ?? []);
                    setGridWithEcosData(gridW?.data ?? []);
                    setBatteryPowerData(batteryPower?.data ?? []);
                    setBatterySOCData(batterySOC?.data ?? []);
                    setLoadForecastData(loadForecast?.data ?? []);
                    setSolarForecastData(solarForecast?.data ?? []);
                    setuserData(userInfoResp);
                }
            } catch (error) {
                console.error("Error fetching data:", error);
            } finally {
                setIsLoading(false);
            }
        };

        // ✅ Fetch immediately on mount / dependency change
        fetchData();

        // ✅ Then repeat every 5 minutes (300,000ms)
        const intervalId = setInterval(fetchData, 4 * 60 * 1000);

        // ✅ Cleanup: clear interval when component unmounts or deps change
        return () => clearInterval(intervalId);

    }, [siteId, selectedDate, timeInterval, TIME_INTERVALS, userType, TIME_INTERVAL]);

    const createChartData = (datasets, keys) => {
        // Ensure datasets are defined and not null
        const sanitizedDatasets = datasets.map((dataset) => dataset || []);

        // Check if all datasets are empty
        if (sanitizedDatasets.every((dataset) => dataset.length === 0)) return [];

        return sanitizedDatasets[0].map((item, index) => {
            const time = Object.values(item)[0]; // Extract the time value
            const modified_time = moment.parseZone(time).format("YYYY-MM-DD HH:mm:ss"); // Parse while preserving the time and ignoring timezone

            const chartData = { timestamp: modified_time };

            sanitizedDatasets.forEach((dataset, datasetIndex) => {
                const key = keys[datasetIndex];
                if (key) {
                    const value = dataset[index]?.[key];
                    // Replace `null` or `undefined` with `NaN`, keep `0` as `0`
                    chartData[key] = value === null || value === undefined ? NaN : value;
                }
            });

            return chartData;
        });
    };

    const roundToNearest30Min = (timestamp) => {
        const momentTime = moment(timestamp);
        const roundedMinutes = Math.round(momentTime.minute() / 30) * 30;
        return momentTime.startOf('hour').add(roundedMinutes, 'minutes').toISOString();
    };

    const formatTo30MinInterval = (datasets) => {
        const sanitizedDatasets = datasets.map((dataset) => dataset || []);

        // Collect all unique, rounded timestamps
        const allRoundedTimestamps = Array.from(
            new Set(
                sanitizedDatasets.flatMap((dataset) =>
                    dataset.map((item) => roundToNearest30Min(Object.values(item)[0]))
                )
            )
        ).sort((a, b) => new Date(a) - new Date(b)); // Sort timestamps

        // Normalize datasets to ensure alignment with the rounded timestamps
        const alignedData = allRoundedTimestamps.map((timestamp) => {
            const chartData = { timestamp: timestamp };

            sanitizedDatasets.forEach((dataset) => {
                if (dataset.length > 0) {
                    const firstKey = Object.keys(dataset[0])[1]; // Get the second key (value)
                    const matchingItem = dataset.find(
                        (item) => roundToNearest30Min(Object.values(item)[0]) === timestamp
                    );
                    chartData[firstKey] = matchingItem ? matchingItem[firstKey] : NaN; // Fill missing values with 0
                }
            });
            return chartData;
        });

        return alignedData;
    };

    // Generate chart data using the preprocessing function
    const forecastcreateChartData = (datasets) => formatTo30MinInterval(datasets);


    const handleLegendClick = (dataKey) => {
        setActiveSeries((prevActiveSeries) =>
            prevActiveSeries.includes(dataKey)
                ? prevActiveSeries.filter((el) => el !== dataKey) // Remove if already active
                : [...prevActiveSeries, dataKey] // Add if not active
        );
    };

    //sum of the  graph
    function aggregateMeterData(meters = []) {
        const combined = {};

        meters.forEach(meter => {
            if (!Array.isArray(meter.data)) return; // skip if meter.data is undefined or not an array

            meter.data.forEach(point => {
                const time = point.recorded_at;
                if (!combined[time]) {
                    combined[time] = { recorded_at: time, total_active_power_kw: null };
                }

                const currentValue = point.total_active_power_kw;

                if (currentValue !== null && !isNaN(currentValue)) {
                    if (combined[time].total_active_power_kw === null) {
                        combined[time].total_active_power_kw = currentValue;
                    } else {
                        combined[time].total_active_power_kw += currentValue;
                    }
                }
            });
        });

        return Object.values(combined);
    }

    const aggregatedData = useMemo(() => {
        return aggregateMeterData(smgridData);
    }, [smgridData]);

    const aggregatedsolarData = useMemo(() => {
        return aggregateMeterData(smsolarData);
    }, [smsolarData]);

    //expanded the small graph
    const [expandedgrid, setExpandedgrid] = useState(false);
    const [expandedsolar, setExpandedsolar] = useState(false);

    useEffect(() => {
        if (!expandedgrid || !siteId || !selectedDate || !timeInterval) return;

        const formattedDate = moment(selectedDate).format("YYYY-MM-DD");
        const selectedValue = TIME_INTERVALS[timeInterval]?.value;

        const fetchGridExpandedData = async () => {
            try {
                const [
                    nema_unbalanceGrid,
                    nema_unbalanceGrid_current,
                    nema_unbalanceGrid_kw,
                    missing_pct_grid,
                    harmonics_current_res,
                    harmonics_voltage_res,
                ] = await Promise.all([
                    nema_unbalanceGridAPI(siteId, formattedDate, selectedValue),
                    nema_unbalanceGrid_currentAPI(siteId, formattedDate, selectedValue),
                    nema_unbalanceGrid_kwAPI(siteId, formattedDate, selectedValue),
                    missing_percentage_grid(siteId, formattedDate),
                    harmonics_current(siteId, formattedDate, selectedValue),
                    harmonics_voltage(siteId, formattedDate, selectedValue),
                ]);

                setNemaUnbalanceGrid(nema_unbalanceGrid?.data ?? []);
                setNemaUnbalanceGridCurrent(nema_unbalanceGrid_current?.data ?? []);
                setNemaUnbalanceGridPower(nema_unbalanceGrid_kw?.data ?? []);
                setHarmonicsCurrent(harmonics_current_res?.data ?? []);
                setHarmonicsVoltage(harmonics_voltage_res?.data ?? []);

                // Build a lookup map: { serial_number: missing_percentage }
                const missingMap = {};
                (missing_pct_grid?.data ?? []).forEach(item => {
                    missingMap[item.serial_number] = item.missing_percentage;
                });
                setMissingPercentages(missingMap);

            } catch (error) {
                console.error("Error fetching grid expanded data:", error);
                setNemaUnbalanceGrid([]);
                setNemaUnbalanceGridCurrent([]);
                setNemaUnbalanceGridPower([]);
                setHarmonicsCurrent([]);
                setHarmonicsVoltage([]);
                setMissingPercentages({});
            }
        };

        fetchGridExpandedData();
    }, [expandedgrid, siteId, selectedDate, timeInterval]);

    // Separate effect for Solar expanded data
    useEffect(() => {
        if (!expandedsolar || !siteId || !selectedDate || !timeInterval) return;

        const formattedDate = moment(selectedDate).format("YYYY-MM-DD");
        const selectedValue = TIME_INTERVALS[timeInterval]?.value;

        const fetchSolarExpandedData = async () => {
            try {
                const [
                    nema_unbalanceSolar,
                    nema_unbalanceSolar_current,
                    nema_unbalanceSolar_kw,
                    missing_pct_solar,
                    harmonics_current_res,
                    harmonics_voltage_res,
                ] = await Promise.all([
                    nema_unbalanceSolarAPI(siteId, formattedDate, selectedValue),
                    nema_unbalanceSolar_currentAPI(siteId, formattedDate, selectedValue),
                    nema_unbalanceSolar_kwAPI(siteId, formattedDate, selectedValue),
                    missing_percentage_solar(siteId, formattedDate),   // ← add
                    harmonics_current_solar(siteId, formattedDate, selectedValue),
                    harmonics_voltage_solar(siteId, formattedDate, selectedValue),
                ]);

                setNemaUnbalanceSolar(nema_unbalanceSolar?.data ?? []);
                setNemaUnbalanceSolarCurrent(nema_unbalanceSolar_current?.data ?? []);
                setNemaUnbalanceSolarPower(nema_unbalanceSolar_kw?.data ?? []);
                setHarmonicsCurrent_solar(harmonics_current_res?.data ?? []);
                setHarmonicsVoltage_solar(harmonics_voltage_res?.data ?? []);

                // Build lookup map
                const missingMap = {};
                (missing_pct_solar?.data ?? []).forEach(item => {
                    missingMap[item.serial_number] = item.missing_percentage;
                });
                setMissingPercentagesSolar(missingMap);   // ← add

            } catch (error) {
                console.error("Error fetching solar expanded data:", error);
                setNemaUnbalanceSolar([]);
                setNemaUnbalanceSolarCurrent([]);
                setNemaUnbalanceSolarPower([]);
                setMissingPercentagesSolar({});   // ← add
            }
        };

        fetchSolarExpandedData();
    }, [expandedsolar, siteId, selectedDate, timeInterval]);


    //check online status of the meter
    function getRecentMeterStatus(meters = []) {
        const now = moment();
        return meters.map(meter => {
            if (!Array.isArray(meter.data)) return false;

            const recentData = meter.data.filter(d =>
                moment(d.recorded_at).isAfter(now.clone().subtract(15, 'minutes'))
            );

            return recentData.some(d => d.total_active_power_kw !== null && !isNaN(d.total_active_power_kw));
        });
    }
    const meterStatusesgrid = useMemo(() => {
        return getRecentMeterStatus(currentSMGrid);
    }, [currentSMGrid]);

    const meterStatusessolar = useMemo(() => {
        return getRecentMeterStatus(currentSMSolar);
    }, [currentSMSolar]);



    function combineChartData(smloadData, aggregatedData, aggregatedsolarData) {
        return smloadData.map((item, index) => ({
            timestamp: item.recorded_at,
            building_load_kw: item.total_active_power_kw,
            grid_power_kw: aggregatedData[index]?.total_active_power_kw ?? null,
            solar_generation_kw: aggregatedsolarData[index]?.total_active_power_kw ?? null,
        }));
    }

    const combinedData = useMemo(() => {
        // Ensure all inputs are arrays before combining
        if (!Array.isArray(smloadData)) {
            console.warn('smloadData is not an array:', smloadData);
            return [];
        }
        if (!Array.isArray(aggregatedData)) {
            console.warn('aggregatedData is not an array:', aggregatedData);
            return [];
        }
        if (!Array.isArray(aggregatedsolarData)) {
            console.warn('aggregatedsolarData is not an array:', aggregatedsolarData);
            return [];
        }

        return combineChartData(smloadData, aggregatedData, aggregatedsolarData);
    }, [smloadData, aggregatedData, aggregatedsolarData]);

    const mergedMeters = useMemo(() => {
        // Check if smgridData is an array
        if (!Array.isArray(smgridData)) {
            console.warn('smgridData is not an array:', smgridData);
            return []; // Return empty array if not valid
        }

        // Check if nemaUnbalanceGrid is an array
        const nemaArray = Array.isArray(nemaUnbalanceGrid) ? nemaUnbalanceGrid : [];

        return smgridData.map((smMeter) => {
            const nemaMeter = nemaArray.find(
                nema => nema.serial_number === smMeter.serial_number
            );
            return {
                ...smMeter,
                nemaData: nemaMeter?.data || [],
                nemaDescription: nemaMeter?.description || ''
            };
        });
    }, [smgridData, nemaUnbalanceGrid]);

    const mergedsolarMeters = useMemo(() => {
        // Check if smsolarData is an array
        if (!Array.isArray(smsolarData)) {
            console.warn('smsolarData is not an array:', smsolarData);
            return []; // Return empty array if not valid
        }

        // Check if nemaUnbalanceSolar is an array
        const nemaArray = Array.isArray(nemaUnbalanceSolar) ? nemaUnbalanceSolar : [];

        return smsolarData.map((smMeter) => {
            const nemaMeter = nemaArray.find(
                nema => nema.serial_number === smMeter.serial_number
            );
            return {
                ...smMeter,
                nemaData: nemaMeter?.data || [],
                nemaDescription: nemaMeter?.description || ''
            };
        });
    }, [smsolarData, nemaUnbalanceSolar]);
    //hide the smartmeter graph line
    // 1️⃣ Declare the state once, at the top of your component
    const [visibleLines, setVisibleLines] = useState({});

    // 2️⃣ Function to toggle visibility
    const SM_handleLegendClick = (meterId, dataKey) => {
        setVisibleLines((prev) => {
            const current = prev[meterId]?.[dataKey] ?? false; // default to false if undefined
            return {
                ...prev,
                [meterId]: {
                    ...prev[meterId],
                    [dataKey]: !current, // toggle visibility
                },
            };
        });
    };


    // Helper function to extract time from datetime string
    const extractTime = (datetime) => {
        if (!datetime) return '';
        if (datetime.match(/^\d{2}:\d{2}:\d{2}$/)) return datetime;
        return datetime.split(' ')[1];
    };

    // Helper function to sum data from multiple meters
    const sumMetersData = (apiResponse) => {
        if (!apiResponse || !Array.isArray(apiResponse)) return [];

        const timestampMap = new Map();

        apiResponse.forEach(meter => {
            if (!meter.data || !Array.isArray(meter.data)) return;

            meter.data.forEach(point => {
                const timestamp = point.recorded_at;
                const value = point.total_active_power_kw;

                // Only process if value is not null/undefined
                if (value !== null && value !== undefined) {
                    if (timestampMap.has(timestamp)) {
                        const existingValue = timestampMap.get(timestamp);
                        // Only add if existing value is not null
                        if (existingValue !== null && existingValue !== undefined) {
                            timestampMap.set(timestamp, existingValue + value);
                        } else {
                            timestampMap.set(timestamp, value);
                        }
                    } else {
                        timestampMap.set(timestamp, value);
                    }
                } else {
                    // If value is null, only set if no value exists yet
                    if (!timestampMap.has(timestamp)) {
                        timestampMap.set(timestamp, null);
                    }
                }
            });
        });

        const summedData = Array.from(timestampMap.entries())
            .map(([recorded_at, total_active_power_kw]) => ({
                recorded_at,
                total_active_power_kw: total_active_power_kw === null ? null : total_active_power_kw
            }))
            .sort((a, b) => a.recorded_at.localeCompare(b.recorded_at));

        return summedData;
    };

    // Fetch comparison data
    const fetchComparisonData = async (type) => {
        try {
            const formattedDate = moment(selectedDate).format("YYYY-MM-DD");
            const selectedValue = 300; // or your TIME_INTERVALS value
            const selectedvalue = TIME_INTERVALS[timeInterval].value;

            let response;
            switch (type) {
                case 'yesterday':
                    response = await sm_gridDatayesterday(siteId, formattedDate, selectedvalue);
                    break;
                case 'sameDayLastWeek':
                    response = await sm_gridDatasamedaylastweek(siteId, formattedDate, selectedvalue);
                    break;
                case 'lastWeekAvg':
                    response = await sm_gridDatalastweekavg(siteId, formattedDate, selectedvalue);
                    break;
                case 'lastMonthAvg':
                    response = await sm_gridDatalastmonthavg(siteId, formattedDate, selectedvalue);
                    break;
                case 'lastYearAvg':
                    response = await sm_gridDatalastyearavg(siteId, formattedDate, selectedvalue);
                    break;
                // case 'accumMax':
                //     response = await accum_max_kw(siteId, formattedDate, selectedvalue);
                //     break;
                default:
                    return;
            }


            if (type === 'accumMax') {
                setComparisonAccumMax(response?.data ?? null);
                setComparisonGridData([]); // clear grid data
                return;
            }

            if (response?.data && Array.isArray(response.data)) {
                const summedData = sumMetersData(response.data);
                setComparisonGridData(summedData);
                setComparisonAccumMax(null); // clear accum max
            } else {
                setComparisonGridData([]);
            }
        } catch (error) {
            console.error(`Error fetching ${type} comparison data: `, error);
        } finally {
        }
    };

    // Handle compare button click
    const handleCompare = (type) => {
        if (comparisonType === type) {
            clearComparison();
        } else {
            setComparisonType(type);
            fetchComparisonData(type);
        }
    };

    // Clear comparison
    const clearComparison = () => {
        setComparisonType(null);
        setComparisonGridData([]);
        setComparisonAccumMax(null);
    };

    // Get chart data with comparison and remove trailing zeros
    const getChartData = () => {
        let currentData = smgridData;

        if (smgridData && Array.isArray(smgridData) && smgridData.length > 0 && smgridData[0]?.data) {
            currentData = sumMetersData(smgridData);
        }

        if (!currentData || currentData.length === 0) return [];

        // ✅ Handle accumMax separately — uses acc_kwh_max_demand array
        if (comparisonType === 'accumMax' && comparisonAccumMax) {
            const accumData = comparisonAccumMax.acc_kwh_max_demand ?? [];
            const comparisonByTime = new Map();
            accumData.forEach(item => {
                const timeKey = extractTime(item.recorded_at);
                if (timeKey && item.total_kw !== null && item.total_kw !== undefined) {
                    comparisonByTime.set(timeKey, item.total_kw); // ✅ total_kw not total_active_power_kw
                }
            });

            return currentData.map(item => {
                const currentTime = extractTime(item.recorded_at);
                const comparisonValue = comparisonByTime.get(currentTime);
                return {
                    recorded_at: item.recorded_at,
                    total_active_power_kw: item.total_active_power_kw ?? null,
                    ...(comparisonValue !== undefined && { comparison_power_kw: comparisonValue }),
                };
            });
        }

        // All other comparison types (yesterday, lastWeek, etc.)
        if (!comparisonGridData || comparisonGridData.length === 0) {
            return currentData.map(item => ({
                recorded_at: item.recorded_at,
                total_active_power_kw: item.total_active_power_kw ?? null,
            }));
        }

        const comparisonByTime = new Map();
        comparisonGridData.forEach(item => {
            const timeKey = extractTime(item.recorded_at);
            if (timeKey && item.total_active_power_kw !== null && item.total_active_power_kw !== undefined) {
                comparisonByTime.set(timeKey, item.total_active_power_kw);
            }
        });

        return currentData.map(item => {
            const currentTime = extractTime(item.recorded_at);
            const comparisonValue = comparisonByTime.get(currentTime);
            return {
                recorded_at: item.recorded_at,
                total_active_power_kw: item.total_active_power_kw ?? null,
                ...(comparisonValue !== undefined && { comparison_power_kw: comparisonValue }),
            };
        });
    };

    // Get display name for comparison
    const getComparisonLabel = () => {
        switch (comparisonType) {
            case 'yesterday': return 'Yesterday';
            case 'sameDayLastWeek': return 'Same Day Last Week';
            case 'lastWeekAvg': return 'Last Week Average';
            case 'lastMonthAvg': return 'Last Month Average';
            case 'lastYearAvg': return 'Last Year Average';
            case 'accumMax': return 'Accumulated Max';
            default: return '';
        }
    };

    // Get color for comparison line
    const getComparisonColor = () => {
        switch (comparisonType) {
            case 'yesterday':
                return '#8884d8';
            case 'sameDayLastWeek':
                return '#8884d8';
            case 'lastWeekAvg':
                return '#8884d8';
            case 'lastMonthAvg':
                return '#8884d8';
            case 'lastYearAvg':
                return '#8884d8';
            case 'accumMax':
                return '#8884d8';
            default:
                return darkMode ? '#8884d8' : '#8884d8';
        }
    };

    // Click outside handler for dropdown
    useEffect(() => {
        const handleClickOutside = (event) => {
            const menu = document.getElementById('compare-menu');
            const compareButton = document.getElementById('compare-button');
            if (menu && compareButton &&
                !menu.contains(event.target) &&
                !compareButton.contains(event.target)) {
                menu.style.display = 'none';
            }
        };

        document.addEventListener('click', handleClickOutside);
        return () => document.removeEventListener('click', handleClickOutside);
    }, []);


    // Add handle functions
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    // Helper function to sum data from multiple solar meters (same as grid)
    const sumSolarMetersData = (apiResponse) => {
        if (!apiResponse || !Array.isArray(apiResponse)) return [];

        const timestampMap = new Map();

        apiResponse.forEach(meter => {
            if (!meter.data || !Array.isArray(meter.data)) return;

            meter.data.forEach(point => {
                const timestamp = point.recorded_at;
                const value = point.total_active_power_kw;

                if (value !== null && value !== undefined) {
                    if (timestampMap.has(timestamp)) {
                        const existingValue = timestampMap.get(timestamp);
                        if (existingValue !== null && existingValue !== undefined) {
                            timestampMap.set(timestamp, existingValue + value);
                        } else {
                            timestampMap.set(timestamp, value);
                        }
                    } else {
                        timestampMap.set(timestamp, value);
                    }
                } else {
                    if (!timestampMap.has(timestamp)) {
                        timestampMap.set(timestamp, null);
                    }
                }
            });
        });

        const summedData = Array.from(timestampMap.entries())
            .map(([recorded_at, total_active_power_kw]) => ({
                recorded_at,
                total_active_power_kw: total_active_power_kw === null ? null : total_active_power_kw
            }))
            .sort((a, b) => a.recorded_at.localeCompare(b.recorded_at));

        return summedData;
    };

    // Fetch Solar comparison data
    const fetchSolarComparisonData = async (type) => {
        try {
            const formattedDate = moment(selectedDate).format("YYYY-MM-DD");
            const selectedValue = 900; // or your TIME_INTERVALS value
            const selectedvalue = TIME_INTERVALS[timeInterval].value;

            let response;
            switch (type) {
                case 'yesterday':
                    response = await sm_solarDatayesterday(siteId, formattedDate, selectedvalue);
                    break;
                case 'sameDayLastWeek':
                    response = await sm_solarDatasamedaylastweek(siteId, formattedDate, selectedvalue);
                    break;
                case 'lastWeekAvg':
                    response = await sm_solarDatalastweekavg(siteId, formattedDate, selectedvalue);
                    break;
                case 'lastMonthAvg':
                    response = await sm_solarDatalastmonthavg(siteId, formattedDate, selectedvalue);
                    break;
                case 'lastYearAvg':
                    response = await sm_solarDatalastyearavg(siteId, formattedDate, selectedvalue);
                    break;
                // case 'accumMax':
                //     response = await accum_max_kw_solar(siteId, formattedDate, selectedvalue);
                //     break;
                default:
                    return;
            }


            if (type === 'accumMax') {
                setSolarComparisonAccumMax(response?.data ?? null); // ✅ solar-specific state
                setComparisonSolarData([]);
                return;
            }
            if (response?.data && Array.isArray(response.data)) {
                const summedData = sumSolarMetersData(response.data);
                setComparisonSolarData(summedData);
                setComparisonAccumMax(null); // clear accum max
            } else {
                setComparisonSolarData([]);
            }
        } catch (error) {
            console.error(`Error fetching solar ${type} comparison data: `, error);
        }
    };



    // Handle compare button click for Solar
    const handleSolarCompare = (type) => {
        if (solarComparisonType === type) {
            clearSolarComparison();
        } else {
            setSolarComparisonType(type);
            fetchSolarComparisonData(type);
        }
    };

    // Clear Solar comparison
    const clearSolarComparison = () => {
        setSolarComparisonType(null);
        setComparisonSolarData([]);
        setSolarComparisonAccumMax(null);
    };

    // Get Solar chart data with comparison
    const getSolarChartData = () => {
        let currentData = smsolarData;

        if (smsolarData && Array.isArray(smsolarData) && smsolarData.length > 0 && smsolarData[0]?.data) {
            currentData = sumSolarMetersData(smsolarData);
        }

        if (!currentData || currentData.length === 0) {
            return [];
        }

        // ✅ Use solarComparisonType (not comparisonType)
        if (solarComparisonType === 'accumMax' && solarComparisonAccumMax) {
            const accumData = solarComparisonAccumMax.acc_kwh_max_demand ?? [];
            const comparisonByTime = new Map();
            accumData.forEach(item => {
                const timeKey = extractTime(item.recorded_at);
                if (timeKey && item.total_kw !== null && item.total_kw !== undefined) {
                    comparisonByTime.set(timeKey, item.total_kw);
                }
            });

            return currentData.map(item => {
                const currentTime = extractTime(item.recorded_at);
                const comparisonValue = comparisonByTime.get(currentTime);
                return {
                    recorded_at: item.recorded_at,
                    total_active_power_kw: item.total_active_power_kw ?? null,
                    ...(comparisonValue !== undefined && { comparison_power_kw: comparisonValue }),
                };
            });
        }

        if (!comparisonSolarData || comparisonSolarData.length === 0) {
            return currentData.map(item => ({
                recorded_at: item.recorded_at,
                total_active_power_kw: item.total_active_power_kw === null ? null : item.total_active_power_kw,
            }));
        }

        const comparisonByTime = new Map();
        comparisonSolarData.forEach(item => {
            const timeKey = extractTime(item.recorded_at);
            if (timeKey && item.total_active_power_kw !== null && item.total_active_power_kw !== undefined) {
                comparisonByTime.set(timeKey, item.total_active_power_kw);
            }
        });

        return currentData.map(item => {
            const currentTime = extractTime(item.recorded_at);
            const comparisonValue = comparisonByTime.get(currentTime);
            return {
                recorded_at: item.recorded_at,
                total_active_power_kw: item.total_active_power_kw === null ? null : item.total_active_power_kw,
                ...(comparisonValue !== undefined && { comparison_power_kw: comparisonValue }),
            };
        });
    };
    // Get display name for Solar comparison
    const getSolarComparisonLabel = () => {
        switch (solarComparisonType) {
            case 'yesterday': return 'Yesterday';
            case 'sameDayLastWeek': return 'Same Day Last Week';
            case 'lastWeekAvg': return 'Last Week Average';
            case 'lastMonthAvg': return 'Last Month Average';
            case 'lastYearAvg': return 'Last Year Average';
            case 'accumMax': return 'Accumulated Max';
            default: return '';
        }
    };

    // Get color for Solar comparison line
    const getSolarComparisonColor = () => {
        switch (solarComparisonType) {
            case 'yesterday':
                return '#8884d8';
            case 'sameDayLastWeek':
                return '#8884d8';
            case 'lastWeekAvg':
                return '#8884d8';
            case 'lastMonthAvg':
                return '#8884d8';
            case 'lastYearAvg':
                return '#8884d8';
            case 'accumMax':
                return '#8884d8';

            default:
                return darkMode ? '#8884d8' : '#8884d8';
        }
    };

    // Add these handlers
    const handleSolarClick = (event) => {
        setSolarAnchorEl(event.currentTarget);
    };

    const handleSolarClose = () => {
        setSolarAnchorEl(null);
    };

    const useHourTicks = (data) => {
        return useMemo(() => {
            if (!data || data.length === 0) return [];

            // Auto-detect which key to use
            const sampleItem = data[0];
            const timeKey = sampleItem?.timestamp ? 'timestamp' :
                sampleItem?.recorded_at ? 'recorded_at' : null;

            if (!timeKey) return [];

            return data
                .map(d => d[timeKey])
                .filter(time => {
                    if (!time) return false;
                    const m = moment(time);
                    return m.isValid() && m.minute() === 0 && m.hour() % 1 === 0;
                });
        }, [data]);
    };

    // Usage - no need to specify the key!
    const gridTicks = useHourTicks(getChartData()); // auto-detects 'recorded_at'
    const combinedTicks = useHourTicks(combinedData); // auto-detects 'timestamp'
    const solarTicks = useHourTicks(getSolarChartData()); // auto-detects 'recorded_at'

    return (
        <>

            {/* Graph Section */}
            {isLoading ? (
                <LoadingOverlay />
            ) : userType === 1 ? (

                <Box
                    sx={{
                        '& > *': { mb: '5rem' },
                        backgroundColor: darkMode ? 'rgba(255,255,255,0.1)' : colors.l7,
                        borderRadius: '20px',
                        paddingBottom: '1%',
                        paddingTop: '20px',
                    }}
                >


                    {/* ------------------------------------Load------------------------------------------ */}
                    <div>

                        {isLoading ? (
                            <LoadingOverlay />
                        ) : smloadData && smloadData.length > 0 ? (
                            <Box sx={{ width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>

                                {/* Main Graph */}
                                <Box sx={{ width: '70%', height: { xs: 300, md: 500 }, mb: 5, mx: 'auto', mt: 2 }}>
                                    <Typography sx={{ mb: 2, textAlign: 'center', color: darkMode ? colors.f2 : colors.f3, fontSize: '1.5rem', fontWeight: 'bold' }}>
                                        Grid, Load & Solar Generation Analysis
                                    </Typography>

                                    <ResponsiveContainer width="100%" height="100%">
                                        <LineChart data={combinedData}>
                                            <CartesianGrid strokeDasharray="3 3" stroke={darkMode ? colors.f2 : colors.f1} />

                                            <XAxis
                                                dataKey="timestamp"
                                                ticks={combinedTicks}
                                                interval={0} // Forces every tick in your hourTicks array to render
                                                tickFormatter={(time) => moment(time).format("HH:mm")}
                                                stroke={darkMode ? colors.f2 : colors.f3}
                                                tick={{ fill: darkMode ? colors.f2 : colors.f3, fontSize: 12 }}
                                                allowDuplicatedCategory={false}
                                                padding={{ right: 10 }}
                                            />

                                            <YAxis
                                                tick={{ fontSize: 12, fill: darkMode ? colors.f2 : colors.f3 }}
                                                label={{
                                                    value: 'Power (kW)',
                                                    angle: -90,
                                                    position: 'insideLeft',
                                                    offset: 10,
                                                    fill: darkMode ? colors.f2 : colors.f3,
                                                }}
                                            />

                                            <Tooltip
                                                formatter={(value, name) => [`${value.toFixed(2)} kW`, name]}
                                                labelFormatter={(label) => `Time: ${moment(label).format('DD-MM-YYYY HH:mm')} `}
                                                contentStyle={{
                                                    backgroundColor: darkMode ? 'rgba(0, 0, 25, 0.8)' : colors.f2,
                                                    color: darkMode ? colors.f2 : colors.f3,
                                                }}
                                            />

                                            <Legend onClick={(props) => handleLegendClick(props.dataKey)} />

                                            <Line
                                                type="monotone"
                                                dataKey="building_load_kw"
                                                stroke={darkMode ? colors.g3 : colors.g11}
                                                strokeWidth={2}
                                                dot={{ r: 2, fill: darkMode ? colors.g3 : colors.g11 }}
                                                animationDuration={1000}
                                                name="Building Load (kW)"
                                                hide={activeSeries.includes('building_load_kw')}
                                                connectNulls={true}
                                            />
                                            <Line
                                                type="monotone"
                                                dataKey="grid_power_kw"
                                                stroke={darkMode ? colors.g4 : colors.g1}
                                                strokeWidth={2}
                                                dot={{ r: 2, fill: darkMode ? colors.g4 : colors.g1 }}
                                                animationDuration={1000}
                                                name="Incoming Grid (kW)"
                                                hide={activeSeries.includes('grid_power_kw')}
                                                connectNulls={true}
                                            />
                                            <Line
                                                type="monotone"
                                                dataKey="solar_generation_kw"
                                                stroke={darkMode ? colors.g2 : colors.g10}
                                                strokeWidth={2}
                                                dot={{ r: 2, fill: darkMode ? colors.g2 : colors.g10 }}
                                                animationDuration={1000}
                                                name="Solar Generation (kW)"
                                                hide={activeSeries.includes('solar_generation_kw')}
                                                connectNulls={true}
                                            />
                                        </LineChart>
                                    </ResponsiveContainer>

                                </Box>

                            </Box>
                        ) : (
                            ""
                        )}
                    </div>

                    {/* ------------------------------------Grid------------------------------------------ */}
                    <div>
                        {isLoading ? (
                            <LoadingOverlay />
                        ) : smgridData && smgridData.length > 0 ? (
                            <Box sx={{ width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>

                                {/* Main Graph */}
                                <Box sx={{ width: '70%', height: { xs: 300, md: 500 }, mb: 5, mx: 'auto', mt: 2 }}>
                                    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', mb: 2 }}>
                                        <Typography sx={{ textAlign: 'center', color: darkMode ? colors.f2 : colors.f3, fontSize: '1.5rem', fontWeight: 'bold' }}>
                                            Grid Analysis
                                        </Typography>
                                    </Box>

                                    <ResponsiveContainer width="100%" height="100%">
                                        <LineChart data={getChartData()}>
                                            <CartesianGrid strokeDasharray="3 3" stroke={darkMode ? colors.f2 : colors.f1} />


                                            <XAxis
                                                dataKey="recorded_at" // Change this to match your data key
                                                ticks={gridTicks}
                                                interval={0}
                                                tickFormatter={(time) => moment(time).format("HH:mm")}
                                                stroke={darkMode ? colors.f2 : colors.f3}
                                                tick={{ fill: darkMode ? colors.f2 : colors.f3, fontSize: 12 }}
                                                allowDuplicatedCategory={false}
                                                padding={{ right: 10 }} // Added left padding to fix the 00:00 alignment
                                            />

                                            <YAxis
                                                tick={{ fontSize: 12, fill: darkMode ? colors.f2 : colors.f3 }}
                                                tickFormatter={(value) => {
                                                    if (value === null || value === undefined) return '';
                                                    return value.toFixed(2);
                                                }}
                                                label={{
                                                    value: 'Power (kW)',
                                                    angle: -90,
                                                    position: 'insideLeft',
                                                    offset: 10,
                                                    fill: darkMode ? colors.f2 : colors.f3,
                                                }}
                                            />

                                            <Tooltip
                                                formatter={(value, name) => {
                                                    const num = Number(value);

                                                    const formatted =
                                                        value === null || value === undefined
                                                            ? 'No data'
                                                            : isNaN(num)
                                                                ? 'Invalid'
                                                                : num.toFixed(2);

                                                    if (name === 'total_active_power_kw') {
                                                        return [formatted, 'Current Grid (kW)'];
                                                    }

                                                    if (name === 'comparison_power_kw') {
                                                        return [formatted, `${getComparisonLabel()} (kW)`];
                                                    }

                                                    return [formatted, name]; // ✅ FIXED (was returning raw value before)
                                                }}
                                                labelFormatter={(label) =>
                                                    `Time: ${moment(label).format('DD-MM-YYYY HH:mm')} `
                                                }
                                                contentStyle={{
                                                    backgroundColor: darkMode ? 'rgba(0, 0, 25, 0.8)' : colors.f2,
                                                    color: darkMode ? colors.f2 : colors.f3,
                                                }}
                                            />

                                            <Legend />

                                            {/* Current Grid Line */}
                                            <Line
                                                type="monotone"
                                                dataKey="total_active_power_kw"
                                                stroke={darkMode ? colors.g4 : colors.g1}
                                                strokeWidth={2}
                                                dot={{ r: 2, fill: darkMode ? colors.g4 : colors.g1 }}
                                                animationDuration={1000}
                                                name="Current Grid (kW)"
                                                connectNulls={false}
                                            />

                                            {/* Comparison Line */}
                                            {(comparisonGridData.length > 0 || comparisonAccumMax !== null) && (
                                                <Line
                                                    type="monotone"
                                                    dataKey="comparison_power_kw"
                                                    stroke={getComparisonColor()}
                                                    strokeWidth={2}
                                                    dot={false}
                                                    animationDuration={1000}
                                                    name={`${getComparisonLabel()} (kW)`}
                                                    connectNulls={false}
                                                />
                                            )}
                                        </LineChart>
                                    </ResponsiveContainer>
                                </Box>

                                {/* Expand/Collapse Button in its own Box below the main graph */}
                                <Box
                                    sx={{
                                        width: '80%',
                                        mx: 'auto',
                                        mt: 5,
                                        mb: 2,
                                        display: 'flex',
                                        justifyContent: 'center',
                                        gap: 2,
                                    }}
                                >

                                    {/* Expand/Collapse Button */}
                                    <Button
                                        variant="outlined"
                                        onClick={() => setExpandedgrid(!expandedgrid)}
                                        sx={{
                                            backgroundColor: darkMode ? colors.d4 : colors.l4,
                                            width: "160px",
                                            height: "50px",
                                            fontSize: "14px",
                                            position: "relative",
                                            zIndex: 1,
                                            color: colors.f2,
                                        }}
                                    >
                                        {expandedgrid ? 'Collapse Details' : 'Expand Details'}
                                    </Button>

                                    {/* Compare Button */}
                                    <Button
                                        id="compare-button"
                                        variant="outlined"
                                        onClick={handleClick}
                                        sx={{
                                            color: darkMode ? colors.f2 : colors.f3,
                                            borderColor: darkMode ? colors.f2 : colors.f3,
                                            '&:hover': {
                                                borderColor: darkMode ? colors.g4 : colors.g1,
                                                backgroundColor: darkMode ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.05)'
                                            }
                                        }}
                                    >
                                        Compare {comparisonType && `(${getComparisonLabel()})`}
                                    </Button>

                                    <Menu
                                        anchorEl={anchorEl}
                                        open={open}
                                        onClose={handleClose}
                                        anchorOrigin={{
                                            vertical: 'bottom',
                                            horizontal: 'left',
                                        }}
                                        transformOrigin={{
                                            vertical: 'top',
                                            horizontal: 'left',
                                        }}
                                        PaperProps={{
                                            elevation: 3,
                                            sx: {
                                                mt: 1,
                                                minWidth: 220,
                                                borderRadius: 2,
                                                overflow: 'hidden',
                                                backgroundColor: darkMode ? colors.bg : 'white',
                                                color: darkMode ? colors.f2 : colors.f3,
                                                boxShadow: '0 6px 18px rgba(0,0,0,0.12)',
                                            }
                                        }}
                                    >
                                        {/* Clear Comparison */}
                                        {comparisonType && (
                                            <>
                                                <MenuItem
                                                    onClick={() => {
                                                        clearComparison();
                                                        handleClose();
                                                    }}
                                                    sx={{
                                                        px: 2,
                                                        py: 1,
                                                        color: 'error.main',
                                                        '&:hover': {
                                                            backgroundColor: 'rgba(255,0,0,0.08)',
                                                        }
                                                    }}
                                                >
                                                    Clear Comparison
                                                </MenuItem>

                                                <Divider />
                                            </>
                                        )}

                                        {/* Options */}
                                        {[
                                            { label: 'Yesterday', value: 'yesterday' },
                                            { label: 'Same Day Last Week', value: 'sameDayLastWeek' },
                                            { label: 'Last Week Average', value: 'lastWeekAvg' },
                                            { label: 'Last Month Average', value: 'lastMonthAvg' },
                                            { label: 'Last Year Average', value: 'lastYearAvg' },
                                            // { label: 'Accumulated Max', value: 'accumMax' },
                                        ].map((item) => {
                                            const isSelected = comparisonType === item.value;

                                            return (
                                                <MenuItem
                                                    key={item.value}
                                                    onClick={() => {
                                                        handleCompare(item.value);
                                                        handleClose();
                                                    }}
                                                    sx={{
                                                        px: 2,
                                                        py: 1,

                                                        // subtle selected indicator (no font change)
                                                        borderLeft: isSelected
                                                            ? `3px solid ${darkMode ? colors.g4 : '#1976d2'} `
                                                            : '3px solid transparent',

                                                        backgroundColor: isSelected
                                                            ? (darkMode
                                                                ? 'rgba(255,255,255,0.06)'
                                                                : 'rgba(25,118,210,0.06)')
                                                            : 'transparent',

                                                        '&:hover': {
                                                            backgroundColor: darkMode
                                                                ? 'rgba(255,255,255,0.1)'
                                                                : 'rgba(0,0,0,0.05)',
                                                        },
                                                    }}
                                                >
                                                    {item.label}
                                                </MenuItem>
                                            );
                                        })}
                                    </Menu>
                                </Box>

                                {/* Show all meters only if expanded */}
                                {expandedgrid && (
                                    <Box
                                        sx={{
                                            display: 'flex',
                                            flexWrap: 'wrap',
                                            gap: 3,
                                            mx: 'auto',
                                            width: '75%',
                                        }}
                                    >
                                        {mergedMeters.map((meter, index) => {
                                            // Find the corresponding NEMA voltage data for this meter
                                            const nemaMeter = nemaUnbalanceGrid.find(n => n.serial_number === meter.serial_number);

                                            const maxUnbalance = Number(
                                                Math.max(
                                                    ...(nemaMeter?.data.map(d => d.nema_unbalanced_pct) || [0]),
                                                    0.5
                                                ).toFixed(2)
                                            );

                                            //find the maximum unbalance pct current data 
                                            const nemaMetercurrent = nemaUnbalanceGridCurrent.find(n => n.serial_number === meter.serial_number);

                                            const maxUnbalancecurrent = Number(
                                                Math.max(
                                                    ...(nemaMetercurrent?.data.map(d => d.nema_unbalanced_pct) || [0]),
                                                    0.5
                                                ).toFixed(2)
                                            );

                                            //find the maximum unbalance pct power data 
                                            const nemaMeterpower = nemaUnbalanceGridPower.find(n => n.serial_number === meter.serial_number);

                                            const maxUnbalancepower = Number(
                                                Math.max(
                                                    ...(nemaMeterpower?.data.map(d => d.nema_unbalanced_pct) || [0]),
                                                    0.5
                                                ).toFixed(2)
                                            );

                                            // Dynamic voltage min/max for left Y-axis
                                            const voltageValues = meter.nemaData?.flatMap(d => [d.voltage_r, d.voltage_y, d.voltage_b]) || [];
                                            const minVoltage = voltageValues.length > 0 ? Math.min(...voltageValues) : 0;
                                            const maxVoltage = voltageValues.length > 0 ? Math.max(...voltageValues) : 250;
                                            const meterVisibility = visibleLines[meter.serial_number] || {
                                                voltage_an_v: false,
                                                voltage_bn_v: false,
                                                voltage_cn_v: false,
                                                current_a_a: false,
                                                current_b_a: false,
                                                current_c_a: false,

                                            };
                                            const processedgridData = meter.nemaData.map((d) => ({
                                                ...d,
                                                Unbalanced: d.nema_unbalanced_pct > 1
                                                    ? Number(d.nema_unbalanced_pct.toFixed(2))
                                                    : null,
                                            }));

                                            const processedgridDatacurrent = nemaMetercurrent?.data.map((d) => ({
                                                ...d,
                                                Unbalanced: d.nema_unbalanced_pct > 10
                                                    ? Number(d.nema_unbalanced_pct.toFixed(2))
                                                    : null,
                                            }));

                                            const processedgridDatapower = nemaMeterpower?.data.map((d) => ({
                                                ...d,
                                                Unbalanced: d.nema_unbalanced_pct > 10
                                                    ? Number(d.nema_unbalanced_pct.toFixed(2))
                                                    : null,
                                            }));

                                            const processedPFData = meter.nemaData?.map((d) => ({
                                                ...d,
                                                total_pf: d.total_pf !== null ? Number(d.total_pf.toFixed(2)) : null,
                                            }));

                                            const power_kva = meter.nemaData?.map((d) => ({
                                                ...d,

                                                total_apparent_power_kva: d.total_apparent_power_kva !== null ? Number(d.total_apparent_power_kva.toFixed(2)) : null,
                                            }));


                                            // Find the corresponding Harmonics Voltage data for this meter
                                            const harmonicsVoltageMeter = (harmonicsVoltage || []).find(n => n.serial_number === meter.serial_number);
                                            const processedHarmonicsVoltage = harmonicsVoltageMeter?.data.map((d) => ({
                                                ...d,
                                                harmonic_voltage_rate_a: d.harmonic_voltage_rate_a !== null ? Number(d.harmonic_voltage_rate_a.toFixed(2)) : null,
                                                harmonic_voltage_rate_b: d.harmonic_voltage_rate_b !== null ? Number(d.harmonic_voltage_rate_b.toFixed(2)) : null,
                                                harmonic_voltage_rate_c: d.harmonic_voltage_rate_c !== null ? Number(d.harmonic_voltage_rate_c.toFixed(2)) : null,
                                            }));

                                            // Find the corresponding Harmonics Current data for this meter
                                            const harmonicsCurrentMeter = (harmonicsCurrent || []).find(n => n.serial_number === meter.serial_number);
                                            const processedHarmonicsCurrent = harmonicsCurrentMeter?.data.map((d) => ({
                                                ...d,
                                                harmonic_current_rate_a: d.harmonic_current_rate_a !== null ? Number(d.harmonic_current_rate_a.toFixed(2)) : null,
                                                harmonic_current_rate_b: d.harmonic_current_rate_b !== null ? Number(d.harmonic_current_rate_b.toFixed(2)) : null,
                                                harmonic_current_rate_c: d.harmonic_current_rate_c !== null ? Number(d.harmonic_current_rate_c.toFixed(2)) : null,
                                            }));


                                            // Plain function (not a hook) - safe to use anywhere including inside .map()
                                            const getHourTicks = (data, timeKey = 'recorded_at') => {
                                                if (!data || data.length === 0) return [];

                                                const seen = new Set();
                                                return data.reduce((ticks, d) => {
                                                    const time = d[timeKey];
                                                    if (!time || seen.has(time)) return ticks;

                                                    const m = moment(time);
                                                    if (m.isValid() && m.minute() === 0 && m.second() === 0) {
                                                        seen.add(time);
                                                        ticks.push(time);
                                                    }
                                                    return ticks;
                                                }, []);
                                            };


                                            const meterGridTicks = getHourTicks(meter.data);
                                            const meterNemaTicks = getHourTicks(processedgridData);
                                            const meterCurrentTicks = getHourTicks(processedgridDatacurrent);
                                            const meterPowerTicks = getHourTicks(processedgridDatapower);
                                            const meterPFTicks = getHourTicks(processedPFData);
                                            const meterKVATicks = getHourTicks(power_kva);
                                            const meterHarmonicsVoltageTicks = getHourTicks(processedHarmonicsVoltage);
                                            const meterHarmonicsCurrentTicks = getHourTicks(processedHarmonicsCurrent);

                                            const hasHarmonicsData = (data, keys) =>
                                                data?.some(row => keys.some(key => row[key] !== null));

                                            return (
                                                <React.Fragment key={index}>
                                                    {/* Meter Card */}
                                                    <Box
                                                        sx={{
                                                            width: '100%',
                                                            mt: 3,
                                                            p: 2,
                                                            backgroundColor: darkMode ? 'rgba(255,255,255,0.05)' : '#f9f9f967',
                                                            borderRadius: '12px',
                                                            boxShadow: darkMode
                                                                ? '0 0 10px rgba(255,255,255,0.1)'
                                                                : '0 0 10px rgba(0,0,0,0.1)',
                                                        }}
                                                    >
                                                        <Typography
                                                            align="center"
                                                            gutterBottom
                                                            sx={{
                                                                color: darkMode ? colors.f2 : colors.f3,
                                                                fontSize: '1.2rem',
                                                            }}
                                                        >
                                                            Grid Consumption{' '}
                                                            {accessLevel === 3 && missingPercentages[meter.serial_number] !== undefined && (
                                                                <Box
                                                                    component="span"
                                                                    sx={{
                                                                        fontSize: '1rem',
                                                                        color: "red",
                                                                    }}
                                                                >
                                                                    (Missing Data: {missingPercentages[meter.serial_number]}%)
                                                                </Box>
                                                            )}
                                                        </Typography>


                                                        <Box
                                                            sx={{
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                justifyContent: 'center',
                                                                gap: '2.5%',
                                                                mb: 1,
                                                            }}
                                                        >
                                                            <Typography
                                                                sx={{
                                                                    fontWeight: 'bold',
                                                                    color: darkMode ? colors.f2 : colors.f3,
                                                                    fontSize: '1.2rem',
                                                                }}
                                                            >
                                                                Smart Meter: {meter.serial_number}
                                                            </Typography>
                                                            <Box
                                                                sx={{
                                                                    width: '1.2vw',
                                                                    height: '2vh',
                                                                    borderRadius: '3vw',
                                                                    backgroundColor: meterStatusesgrid[index] ? 'green' : 'red',
                                                                    position: 'relative',
                                                                    transition: 'background-color 0.3s',
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    px: '1.6%',
                                                                }}
                                                            >
                                                                <Box
                                                                    sx={{
                                                                        width: '0.8vw',
                                                                        height: '0.8vw',
                                                                        borderRadius: '50%',
                                                                        backgroundColor: 'white',
                                                                        position: 'absolute',
                                                                        left: meterStatusesgrid[index] ? '52%' : '10%',
                                                                        transition: 'left 0.3s',
                                                                    }}
                                                                />
                                                            </Box>
                                                        </Box>

                                                        {/* Description */}
                                                        <Box
                                                            sx={{
                                                                height: "auto",
                                                                width: "auto",
                                                                display: "flex", // fixed the typo "felx"
                                                                justifyContent: "center", // center both text + icon
                                                                alignItems: "center",
                                                                flexDirection: "row",
                                                                gap: "3%", // adds nice small spacing between text and icon
                                                            }}
                                                        >
                                                            <Typography
                                                                align="center"
                                                                gutterBottom
                                                                sx={{
                                                                    color: darkMode ? colors.f2 : colors.f3,
                                                                    fontSize: '1.1rem',
                                                                    display: "flex", // make text + icon inline
                                                                    alignItems: "center",
                                                                }}
                                                            >
                                                                Description: {meter.description}

                                                                <MuiTooltip
                                                                    title="To view the voltage data, simply click the label below the graph."
                                                                    placement="right"
                                                                    arrow
                                                                >
                                                                    <HelpOutlineIcon
                                                                        sx={{
                                                                            fontSize: '1rem',
                                                                            cursor: 'pointer',
                                                                            ml: 0.5,
                                                                            color: colors.f1,
                                                                        }}
                                                                    />
                                                                </MuiTooltip>
                                                            </Typography>
                                                        </Box>


                                                        <Box sx={{ display: 'flex', justifyContent: 'center', flexWrap: 'wrap', mt: 4, gap: 2 }}>
                                                            {/* Smart Meter graph */}

                                                            {graphToggles?.consumption && (
                                                                meter.data?.length > 0 ? (
                                                                    <Box sx={{ width: '48%', height: 350, mb: 6 }}>
                                                                        <Typography
                                                                            variant="subtitle1"
                                                                            sx={{
                                                                                mb: 1,
                                                                                fontWeight: 600,
                                                                                textAlign: 'center',
                                                                                color: darkMode ? colors.f2 : colors.f3
                                                                            }}
                                                                        >
                                                                            Grid Consumption (kW)
                                                                        </Typography>
                                                                        <ResponsiveContainer width="100%" height="100%">
                                                                            <LineChart data={meter.data}>
                                                                                <CartesianGrid
                                                                                    strokeDasharray="3 3"
                                                                                    stroke={darkMode ? colors.f2 : colors.f1}
                                                                                />
                                                                                <XAxis
                                                                                    dataKey="recorded_at"
                                                                                    ticks={meterGridTicks}
                                                                                    interval={0}
                                                                                    tickFormatter={(tick) => moment(tick).format('HH:mm')}
                                                                                    tick={{ fontSize: 12, fill: darkMode ? colors.f2 : colors.f3 }}
                                                                                    angle={-65}
                                                                                    textAnchor="end"
                                                                                    height={60}
                                                                                />
                                                                                <YAxis
                                                                                    tick={{ fontSize: 12, fill: darkMode ? colors.f2 : colors.f3 }}
                                                                                    label={{
                                                                                        value: 'Power (kW)',
                                                                                        angle: -90,
                                                                                        position: 'insideLeft',
                                                                                        offset: 10,
                                                                                        fill: darkMode ? colors.f2 : colors.f3,
                                                                                    }}
                                                                                />
                                                                                <Tooltip
                                                                                    formatter={(v) => [v.toFixed(2), 'Incoming Grid (kW)']}
                                                                                    labelFormatter={(label) =>
                                                                                        `Time: ${moment(label).format('DD-MM-YYYY HH:mm')} `
                                                                                    }
                                                                                    contentStyle={{
                                                                                        backgroundColor: darkMode ? 'rgba(0, 0, 25, 0.8)' : colors.f2,
                                                                                        color: darkMode ? colors.f2 : colors.f3,
                                                                                    }}
                                                                                />
                                                                                <Legend verticalAlign="bottom" height={36} />
                                                                                <Line
                                                                                    type="monotone"
                                                                                    dataKey="total_active_power_kw"
                                                                                    stroke={darkMode ? colors.g4 : colors.g1}
                                                                                    strokeWidth={2}
                                                                                    dot={{ r: 2, fill: darkMode ? colors.g4 : colors.g1 }}
                                                                                    animationDuration={1000}
                                                                                    name="Incoming Grid (kW)"
                                                                                    connectNulls
                                                                                />
                                                                            </LineChart>
                                                                        </ResponsiveContainer>
                                                                    </Box>
                                                                ) : (
                                                                    <Box sx={{ width: '48%', height: 350, mb: 6 }}>
                                                                        <Typography align="center" color="text.secondary">
                                                                            No data available for graph.
                                                                        </Typography>
                                                                    </Box>
                                                                )
                                                            )}

                                                            {/* Power Phase Unbalance graph */}
                                                            {graphToggles?.phase_diff_kw &&
                                                                <Box sx={{ width: '48%', height: 350, mb: 6 }}>
                                                                    <Typography
                                                                        variant="subtitle1"
                                                                        sx={{
                                                                            mb: 1,
                                                                            fontWeight: 600,
                                                                            textAlign: 'center',
                                                                            color: darkMode ? colors.f2 : colors.f3
                                                                        }}
                                                                    >
                                                                        Phase difference (kW)
                                                                    </Typography>
                                                                    {processedgridDatapower?.length > 0 ? (
                                                                        <ResponsiveContainer width="100%" height="100%">
                                                                            <ComposedChart data={processedgridDatapower}>
                                                                                <CartesianGrid strokeDasharray="3 3" />

                                                                                <XAxis
                                                                                    dataKey="recorded_at"
                                                                                    ticks={meterPowerTicks}
                                                                                    interval={0}
                                                                                    tickFormatter={(tick) => moment(tick).format('HH:mm')}
                                                                                    tick={{ fontSize: 12, fill: darkMode ? colors.f2 : colors.f3 }}
                                                                                    angle={-65}
                                                                                    textAnchor="end"
                                                                                    height={60}
                                                                                />
                                                                                <YAxis
                                                                                    yAxisId="left"
                                                                                    domain={[minVoltage, maxVoltage + 5]}
                                                                                    label={{
                                                                                        value: 'Active Power (kW)',
                                                                                        angle: -90,
                                                                                        position: 'insideLeft',
                                                                                        style: { fontSize: '0.6vw' },
                                                                                    }}
                                                                                    tickFormatter={(value) => value.toFixed(1)}
                                                                                    tick={{ fontSize: 12, fill: darkMode ? colors.f2 : colors.f3 }}
                                                                                />

                                                                                {/* <YAxis
                                                                                yAxisId="right"
                                                                                orientation="right"
                                                                                tickFormatter={(value) => value.toFixed(2)}
                                                                                domain={[0, maxUnbalancepower + 0.1]}
                                                                                label={{
                                                                                    value: 'Unbalanced (%)',
                                                                                    angle: -90,
                                                                                    position: 'insideRight',
                                                                                    style: { fontSize: '0.6vw' },
                                                                                }}
                                                                                tick={{ fontSize: 12, fill: darkMode ? colors.f2 : colors.f3 }}
                                                                            /> */}

                                                                                <Tooltip
                                                                                    formatter={(value, name) => [Number(value).toFixed(2), name]}
                                                                                    labelFormatter={(label) => `Time: ${moment(label).format('DD-MM-YYYY HH:mm')} `}
                                                                                />
                                                                                <Legend
                                                                                    verticalAlign="bottom"
                                                                                    height={36}
                                                                                    wrapperStyle={{ fontSize: '0.7vw' }}
                                                                                    onClick={(e) => SM_handleLegendClick(meter.serial_number, e.dataKey)}
                                                                                    formatter={(value) => (value === 'Unbalanced' ? null : value)}
                                                                                />

                                                                                <Line
                                                                                    yAxisId="left"
                                                                                    type="monotone"
                                                                                    dataKey="active_power_a_kw"
                                                                                    name="Active Power A (kW)"
                                                                                    stroke="#ff7300"
                                                                                    strokeWidth={2}
                                                                                    dot={false}
                                                                                    connectNulls
                                                                                    opacity={meterVisibility.active_power_a_kw === false ? 0 : 1}
                                                                                />
                                                                                <Line
                                                                                    yAxisId="left"
                                                                                    type="monotone"
                                                                                    dataKey="active_power_b_kw"
                                                                                    name="Active Power B (kW)"
                                                                                    stroke="#ffc658"
                                                                                    strokeWidth={2}
                                                                                    dot={false}
                                                                                    connectNulls
                                                                                    opacity={meterVisibility.active_power_b_kw === false ? 0 : 1}
                                                                                />
                                                                                <Line
                                                                                    yAxisId="left"
                                                                                    type="monotone"
                                                                                    dataKey="active_power_c_kw"
                                                                                    name="Active Power C (kW)"
                                                                                    stroke="#6394cc"
                                                                                    strokeWidth={2}
                                                                                    dot={false}
                                                                                    connectNulls
                                                                                    opacity={meterVisibility.active_power_c_kw === false ? 0 : 1}
                                                                                />

                                                                                {/* <Area
                                                                                yAxisId="right"
                                                                                type="monotone"
                                                                                dataKey="nema_unbalanced_pct"
                                                                                name="NEMA Power Unbalanced (%)"
                                                                                fill="#74b800"
                                                                                stroke="#74b800"
                                                                                strokeWidth={2}
                                                                                fillOpacity={0.3}
                                                                                connectNulls
                                                                            /> */}

                                                                                <Brush
                                                                                    dataKey="recorded_at"
                                                                                    height={20}
                                                                                    stroke={darkMode ? colors.g4 : '#8884d8'}
                                                                                    travellerWidth={10}
                                                                                    tickFormatter={(tick) => moment(tick).format('HH:mm')}
                                                                                />
                                                                            </ComposedChart>
                                                                        </ResponsiveContainer>
                                                                    ) : (
                                                                        <Typography align="center" color="text.secondary">
                                                                            No Power Phase Unbalance data.
                                                                        </Typography>
                                                                    )}
                                                                </Box>}

                                                            {/* Voltage Unbalanced graph */}
                                                            {graphToggles?.phase_diff_voltage &&
                                                                <Box sx={{ width: '48%', height: 350, mb: 6 }}>
                                                                    <Typography
                                                                        variant="subtitle1"
                                                                        sx={{
                                                                            mb: 1,
                                                                            fontWeight: 600,
                                                                            textAlign: 'center',
                                                                            color: darkMode ? colors.f2 : colors.f3
                                                                        }}
                                                                    >
                                                                        Phase difference (V)
                                                                    </Typography>
                                                                    {meter.nemaData?.length > 0 ? (
                                                                        <ResponsiveContainer width="100%" height="100%">
                                                                            <ComposedChart data={processedgridData}>
                                                                                <CartesianGrid strokeDasharray="3 3" />

                                                                                <XAxis
                                                                                    dataKey="recorded_at"
                                                                                    ticks={meterNemaTicks}
                                                                                    interval={0}
                                                                                    tickFormatter={(tick) => moment(tick).format('HH:mm')}
                                                                                    tick={{ fontSize: 12, fill: darkMode ? colors.f2 : colors.f3 }}
                                                                                    angle={-65}
                                                                                    textAnchor="end"
                                                                                    height={60}
                                                                                />

                                                                                <YAxis
                                                                                    yAxisId="left"
                                                                                    domain={[minVoltage, maxVoltage + 5]}
                                                                                    tickFormatter={(value) => value.toFixed(1)}
                                                                                    label={{ value: 'Voltage (V)', angle: -90, position: 'insideLeft', style: { fontSize: '0.6vw' }, dx: -5, }}
                                                                                />

                                                                                <YAxis
                                                                                    yAxisId="right"
                                                                                    orientation="right"
                                                                                    domain={[0, maxUnbalance + 0.1]}
                                                                                    tickFormatter={(value) => value.toFixed(2)}
                                                                                    label={{
                                                                                        value: 'Unbalanced (%)',
                                                                                        angle: -90,
                                                                                        position: 'insideRight',
                                                                                        style: { fontSize: '0.6vw' },
                                                                                    }}
                                                                                />

                                                                                <Tooltip
                                                                                    formatter={(value, name) => [Number(value).toFixed(2), name]}
                                                                                    labelFormatter={(label) => `Time: ${moment(label).format('DD-MM-YYYY HH:mm')} `}
                                                                                />

                                                                                <Legend
                                                                                    verticalAlign="bottom"
                                                                                    height={36}
                                                                                    wrapperStyle={{ fontSize: '0.7vw' }}
                                                                                    onClick={(e) => SM_handleLegendClick(meter.serial_number, e.dataKey)}
                                                                                    formatter={(value) => (value === 'Unbalanced' ? null : value)}
                                                                                />

                                                                                <Area
                                                                                    yAxisId="right"
                                                                                    type="monotone"
                                                                                    dataKey="nema_unbalanced_pct"
                                                                                    name="NEMA Unbalanced (%)"
                                                                                    fill="#74b800"
                                                                                    stroke="#74b800"
                                                                                    strokeWidth={2}
                                                                                    fillOpacity={0.3}
                                                                                    connectNulls
                                                                                />

                                                                                <Area
                                                                                    yAxisId="right"
                                                                                    type="monotone"
                                                                                    dataKey="Unbalanced"
                                                                                    name=""
                                                                                    fill="red"
                                                                                    stroke="red"
                                                                                    strokeWidth={2}
                                                                                    fillOpacity={0.5}
                                                                                    connectNulls={false}
                                                                                    legendType="none"
                                                                                />

                                                                                <Line
                                                                                    yAxisId="left"
                                                                                    type="monotone"
                                                                                    dataKey="voltage_an_v"
                                                                                    name="Voltage AN (V)"
                                                                                    stroke="#ff7300"
                                                                                    strokeWidth={2}
                                                                                    dot={false}
                                                                                    connectNulls
                                                                                    opacity={meterVisibility.voltage_an_v === false ? 0 : 1}
                                                                                />
                                                                                <Line
                                                                                    yAxisId="left"
                                                                                    type="monotone"
                                                                                    dataKey="voltage_bn_v"
                                                                                    name="Voltage BN (V)"
                                                                                    stroke="#ffc658"
                                                                                    strokeWidth={2}
                                                                                    dot={false}
                                                                                    connectNulls
                                                                                    opacity={meterVisibility.voltage_bn_v === false ? 0 : 1}
                                                                                />
                                                                                <Line
                                                                                    yAxisId="left"
                                                                                    type="monotone"
                                                                                    dataKey="voltage_cn_v"
                                                                                    name="Voltage CN (V)"
                                                                                    stroke="#6394cc"
                                                                                    strokeWidth={2}
                                                                                    dot={false}
                                                                                    connectNulls
                                                                                    opacity={meterVisibility.voltage_cn_v === false ? 0 : 1}
                                                                                />

                                                                                <Brush
                                                                                    dataKey="recorded_at"
                                                                                    height={20}
                                                                                    stroke={darkMode ? colors.g4 : '#8884d8'}
                                                                                    travellerWidth={10}
                                                                                    tickFormatter={(tick) => moment(tick).format('HH:mm')}
                                                                                />
                                                                            </ComposedChart>
                                                                        </ResponsiveContainer>
                                                                    ) : (
                                                                        <Typography align="center" color="text.secondary">
                                                                            No NEMA data.
                                                                        </Typography>
                                                                    )}
                                                                </Box>}

                                                            {/* Current Phase Unbalance graph */}
                                                            {graphToggles?.phase_diff_current &&
                                                                <Box sx={{ width: '48%', height: 350, mb: 6 }}>
                                                                    <Typography
                                                                        variant="subtitle1"
                                                                        sx={{
                                                                            mb: 1,
                                                                            fontWeight: 600,
                                                                            textAlign: 'center',
                                                                            color: darkMode ? colors.f2 : colors.f3
                                                                        }}
                                                                    >
                                                                        Phase difference (A)
                                                                    </Typography>
                                                                    {nemaUnbalanceGridCurrent?.length > 0 ? (
                                                                        <ResponsiveContainer width="100%" height="100%">
                                                                            <ComposedChart data={processedgridDatacurrent}>
                                                                                <CartesianGrid strokeDasharray="3 3" />

                                                                                <XAxis
                                                                                    dataKey="recorded_at"
                                                                                    ticks={meterCurrentTicks}
                                                                                    interval={0}
                                                                                    tickFormatter={(tick) => moment(tick).format('HH:mm')}
                                                                                    tick={{ fontSize: 12, fill: darkMode ? colors.f2 : colors.f3 }}
                                                                                    angle={-65}
                                                                                    textAnchor="end"
                                                                                    height={60}
                                                                                />

                                                                                <YAxis
                                                                                    yAxisId="left"
                                                                                    domain={[minVoltage, maxVoltage + 5]}
                                                                                    label={{
                                                                                        value: 'Current (A)',
                                                                                        angle: -90,
                                                                                        position: 'insideLeft',
                                                                                        style: { fontSize: '0.6vw' },
                                                                                    }}
                                                                                    tickFormatter={(value) => value.toFixed(1)}
                                                                                    tick={{ fontSize: 12, fill: darkMode ? colors.f2 : colors.f3 }}
                                                                                />

                                                                                <YAxis
                                                                                    yAxisId="right"
                                                                                    orientation="right"
                                                                                    tickFormatter={(value) => value.toFixed(2)}
                                                                                    domain={[0, maxUnbalancecurrent + 1]}
                                                                                    label={{
                                                                                        value: 'Unbalanced (%)',
                                                                                        angle: -90,
                                                                                        position: 'insideRight',
                                                                                        style: { fontSize: '0.6vw' },
                                                                                    }}
                                                                                    tick={{ fontSize: 12, fill: darkMode ? colors.f2 : colors.f3 }}
                                                                                />

                                                                                <Tooltip
                                                                                    formatter={(value, name) => [Number(value).toFixed(2), name]}
                                                                                    labelFormatter={(label) => `Time: ${moment(label).format('DD-MM-YYYY HH:mm')} `}
                                                                                />

                                                                                <Legend
                                                                                    verticalAlign="bottom"
                                                                                    height={36}
                                                                                    wrapperStyle={{ fontSize: '0.7vw' }}
                                                                                    onClick={(e) => SM_handleLegendClick(meter.serial_number, e.dataKey)}
                                                                                    formatter={(value) => (value === 'Unbalanced' ? null : value)}
                                                                                />

                                                                                <Area
                                                                                    yAxisId="right"
                                                                                    type="monotone"
                                                                                    dataKey="nema_unbalanced_pct"
                                                                                    name="NEMA Current Unbalanced (%)"
                                                                                    fill="#74b800"
                                                                                    stroke="#74b800"
                                                                                    strokeWidth={2}
                                                                                    fillOpacity={0.3}
                                                                                    connectNulls
                                                                                />

                                                                                <Area
                                                                                    yAxisId="right"
                                                                                    type="monotone"
                                                                                    dataKey="Unbalanced"
                                                                                    name=""
                                                                                    fill="red"
                                                                                    stroke="red"
                                                                                    strokeWidth={2}
                                                                                    fillOpacity={0.5}
                                                                                    connectNulls={false}
                                                                                    legendType="none"
                                                                                />

                                                                                <Line
                                                                                    yAxisId="left"
                                                                                    type="monotone"
                                                                                    dataKey="current_a_a"
                                                                                    name="Current A (A)"
                                                                                    stroke="#ff7300"
                                                                                    strokeWidth={2}
                                                                                    dot={false}
                                                                                    connectNulls
                                                                                    opacity={meterVisibility.current_a_a === false ? 0 : 1}
                                                                                />
                                                                                <Line
                                                                                    yAxisId="left"
                                                                                    type="monotone"
                                                                                    dataKey="current_b_a"
                                                                                    name="Current B (A)"
                                                                                    stroke="#ffc658"
                                                                                    strokeWidth={2}
                                                                                    dot={false}
                                                                                    connectNulls
                                                                                    opacity={meterVisibility.current_b_a === false ? 0 : 1}
                                                                                />
                                                                                <Line
                                                                                    yAxisId="left"
                                                                                    type="monotone"
                                                                                    dataKey="current_c_a"
                                                                                    name="Current C (A)"
                                                                                    stroke="#6394cc"
                                                                                    strokeWidth={2}
                                                                                    dot={false}
                                                                                    connectNulls
                                                                                    opacity={meterVisibility.current_c_a === false ? 0 : 1}
                                                                                />

                                                                                <Brush
                                                                                    dataKey="recorded_at"
                                                                                    height={20}
                                                                                    stroke={darkMode ? colors.g4 : '#8884d8'}
                                                                                    travellerWidth={10}
                                                                                    tickFormatter={(tick) => moment(tick).format('HH:mm')}
                                                                                />
                                                                            </ComposedChart>
                                                                        </ResponsiveContainer>
                                                                    ) : (
                                                                        <Typography align="center" color="text.secondary">
                                                                            No Current Phase Unbalance data.
                                                                        </Typography>
                                                                    )}
                                                                </Box>}

                                                            {/* Power Factor Graph */}
                                                            {graphToggles?.power_factor &&
                                                                <Box sx={{ width: '48%', height: 350, mb: 6 }}>
                                                                    <Typography
                                                                        variant="subtitle1"
                                                                        sx={{
                                                                            mb: 1,
                                                                            fontWeight: 600,
                                                                            textAlign: 'center',
                                                                            color: darkMode ? colors.f2 : colors.f3
                                                                        }}
                                                                    >
                                                                        Power Factor
                                                                    </Typography>
                                                                    {processedPFData?.length > 0 ? (
                                                                        <ResponsiveContainer width="100%" height="100%">
                                                                            <LineChart data={processedPFData}>
                                                                                <CartesianGrid strokeDasharray="3 3" />

                                                                                <XAxis
                                                                                    dataKey="recorded_at"
                                                                                    ticks={meterPFTicks}
                                                                                    interval={0}
                                                                                    tickFormatter={(tick) => moment(tick).format('HH:mm')}
                                                                                    tick={{ fontSize: 12, fill: darkMode ? colors.f2 : colors.f3 }}
                                                                                    angle={-65}
                                                                                    textAnchor="end"
                                                                                    height={60}
                                                                                />

                                                                                <YAxis
                                                                                    domain={[0, 1]}
                                                                                    tickFormatter={(value) => value.toFixed(2)}
                                                                                    label={{
                                                                                        value: 'Power Factor (PF)',
                                                                                        angle: -90,
                                                                                        position: 'insideLeft',
                                                                                        style: { fontSize: '0.6vw' },
                                                                                    }}
                                                                                    tick={{ fontSize: 12, fill: darkMode ? colors.f2 : colors.f3 }}
                                                                                />

                                                                                <Tooltip
                                                                                    formatter={(value) => [Number(value).toFixed(2), 'Power Factor']}
                                                                                    labelFormatter={(label) =>
                                                                                        `Time: ${moment(label).format('DD-MM-YYYY HH:mm')} `
                                                                                    }
                                                                                    contentStyle={{
                                                                                        backgroundColor: darkMode
                                                                                            ? 'rgba(0, 0, 25, 0.8)'
                                                                                            : colors.f2,
                                                                                        color: darkMode ? colors.f2 : colors.f3,
                                                                                    }}
                                                                                />

                                                                                <Legend
                                                                                    verticalAlign="bottom"
                                                                                    height={36}
                                                                                />

                                                                                <Line
                                                                                    type="monotone"
                                                                                    dataKey="total_pf"
                                                                                    name="Total Power Factor"
                                                                                    stroke={darkMode ? colors.g1 : colors.g1}
                                                                                    strokeWidth={2}
                                                                                    dot={false}
                                                                                    connectNulls
                                                                                />

                                                                                <Brush
                                                                                    dataKey="recorded_at"
                                                                                    height={20}
                                                                                    stroke={darkMode ? colors.g4 : '#8884d8'}
                                                                                    travellerWidth={10}
                                                                                    tickFormatter={(tick) => moment(tick).format('HH:mm')}
                                                                                />
                                                                            </LineChart>
                                                                        </ResponsiveContainer>
                                                                    ) : (
                                                                        <Typography align="center" color="text.secondary">
                                                                            No Power Factor data.
                                                                        </Typography>
                                                                    )}
                                                                </Box>}

                                                            {/* Total Apparent Power Graph */}
                                                            {graphToggles?.apparent_power &&
                                                                <Box sx={{ width: '48%', height: 350, mb: 6 }}>
                                                                    <Typography
                                                                        variant="subtitle1"
                                                                        sx={{
                                                                            mb: 1,
                                                                            fontWeight: 600,
                                                                            textAlign: 'center',
                                                                            color: darkMode ? colors.f2 : colors.f3
                                                                        }}
                                                                    >
                                                                        Apparent Power
                                                                    </Typography>
                                                                    {power_kva?.length > 0 ? (
                                                                        <ResponsiveContainer width="100%" height="100%">
                                                                            <LineChart data={power_kva}>
                                                                                <CartesianGrid strokeDasharray="3 3" />

                                                                                <XAxis
                                                                                    dataKey="recorded_at"
                                                                                    ticks={meterKVATicks}
                                                                                    interval={0}
                                                                                    tickFormatter={(tick) => moment(tick).format('HH:mm')}
                                                                                    tick={{ fontSize: 12, fill: darkMode ? colors.f2 : colors.f3 }}
                                                                                    angle={-65}
                                                                                    textAnchor="end"
                                                                                    height={60}
                                                                                />

                                                                                <YAxis
                                                                                    tickFormatter={(value) => value.toFixed(2)}
                                                                                    label={{
                                                                                        value: 'Apparent Power',
                                                                                        angle: -90,
                                                                                        position: 'insideLeft',
                                                                                        style: { fontSize: '0.6vw' },
                                                                                    }}
                                                                                    tick={{ fontSize: 12, fill: darkMode ? colors.f2 : colors.f3 }}
                                                                                />

                                                                                <Tooltip
                                                                                    formatter={(value) => [Number(value).toFixed(2), 'Apparent Power ']}
                                                                                    labelFormatter={(label) =>
                                                                                        `Time: ${moment(label).format('DD-MM-YYYY HH:mm')} `
                                                                                    }
                                                                                    contentStyle={{
                                                                                        backgroundColor: darkMode
                                                                                            ? 'rgba(0, 0, 25, 0.8)'
                                                                                            : colors.f2,
                                                                                        color: darkMode ? colors.f2 : colors.f3,
                                                                                    }}
                                                                                />

                                                                                <Legend
                                                                                    verticalAlign="bottom"
                                                                                    height={36}
                                                                                />

                                                                                <Line
                                                                                    type="monotone"
                                                                                    dataKey="total_apparent_power_kva"
                                                                                    name="Apparent Power "
                                                                                    stroke={darkMode ? colors.g1 : colors.g1}
                                                                                    strokeWidth={2}
                                                                                    dot={false}
                                                                                    connectNulls
                                                                                />

                                                                                <Brush
                                                                                    dataKey="recorded_at"
                                                                                    height={20}
                                                                                    stroke={darkMode ? colors.g4 : '#8884d8'}
                                                                                    travellerWidth={10}
                                                                                    tickFormatter={(tick) => moment(tick).format('HH:mm')}
                                                                                />
                                                                            </LineChart>
                                                                        </ResponsiveContainer>
                                                                    ) : (
                                                                        <Typography align="center" color="text.secondary">
                                                                            No Apparent Power data.
                                                                        </Typography>
                                                                    )}
                                                                </Box>}

                                                            {/* Voltage Harmonics Graph */}
                                                            {graphToggles?.voltage_harmonics && hasHarmonicsData(processedHarmonicsVoltage, ['harmonic_voltage_rate_a', 'harmonic_voltage_rate_b', 'harmonic_voltage_rate_c']) && (
                                                                <Box sx={{ width: '48%', height: 350, mb: 6 }}>
                                                                    <Typography
                                                                        variant="subtitle1"
                                                                        sx={{
                                                                            mb: 1,
                                                                            fontWeight: 600,
                                                                            textAlign: 'center',
                                                                            color: darkMode ? colors.f2 : colors.f3
                                                                        }}
                                                                    >
                                                                        Voltage Harmonics (%)
                                                                    </Typography>
                                                                    {processedHarmonicsVoltage?.length > 0 ? (
                                                                        <ResponsiveContainer width="100%" height="100%">
                                                                            <ComposedChart data={processedHarmonicsVoltage}>
                                                                                <CartesianGrid strokeDasharray="3 3" />

                                                                                <XAxis
                                                                                    dataKey="recorded_at"
                                                                                    ticks={meterHarmonicsVoltageTicks}
                                                                                    interval={0}
                                                                                    tickFormatter={(tick) => moment(tick).format('HH:mm')}
                                                                                    tick={{ fontSize: 12, fill: darkMode ? colors.f2 : colors.f3 }}
                                                                                    angle={-65}
                                                                                    textAnchor="end"
                                                                                    height={60}
                                                                                />

                                                                                <YAxis
                                                                                    tickFormatter={(value) => value.toFixed(2)}
                                                                                    label={{
                                                                                        value: 'THD (%)',
                                                                                        angle: -90,
                                                                                        position: 'insideLeft',
                                                                                        style: { fontSize: '0.6vw' },
                                                                                    }}
                                                                                    tick={{ fontSize: 12, fill: darkMode ? colors.f2 : colors.f3 }}
                                                                                />

                                                                                <Tooltip
                                                                                    formatter={(value, name) => [Number(value).toFixed(2), name]}
                                                                                    labelFormatter={(label) => `Time: ${moment(label).format('DD-MM-YYYY HH:mm')} `}
                                                                                />

                                                                                <Legend
                                                                                    verticalAlign="bottom"
                                                                                    height={36}
                                                                                    wrapperStyle={{ fontSize: '0.7vw' }}
                                                                                    onClick={(e) => SM_handleLegendClick(meter.serial_number, e.dataKey)}
                                                                                />

                                                                                <Line
                                                                                    type="monotone"
                                                                                    dataKey="harmonic_voltage_rate_a"
                                                                                    name="Voltage Harmonics A (%)"
                                                                                    stroke="#ff7300"
                                                                                    strokeWidth={2}
                                                                                    dot={false}
                                                                                    connectNulls
                                                                                    opacity={meterVisibility.harmonic_voltage_rate_a === false ? 0 : 1}
                                                                                />
                                                                                <Line
                                                                                    type="monotone"
                                                                                    dataKey="harmonic_voltage_rate_b"
                                                                                    name="Voltage Harmonics B (%)"
                                                                                    stroke="#ffc658"
                                                                                    strokeWidth={2}
                                                                                    dot={false}
                                                                                    connectNulls
                                                                                    opacity={meterVisibility.harmonic_voltage_rate_b === false ? 0 : 1}
                                                                                />
                                                                                <Line
                                                                                    type="monotone"
                                                                                    dataKey="harmonic_voltage_rate_c"
                                                                                    name="Voltage Harmonics C (%)"
                                                                                    stroke="#6394cc"
                                                                                    strokeWidth={2}
                                                                                    dot={false}
                                                                                    connectNulls
                                                                                    opacity={meterVisibility.harmonic_voltage_rate_c === false ? 0 : 1}
                                                                                />

                                                                                <Brush
                                                                                    dataKey="recorded_at"
                                                                                    height={20}
                                                                                    stroke={darkMode ? colors.g4 : '#8884d8'}
                                                                                    travellerWidth={10}
                                                                                    tickFormatter={(tick) => moment(tick).format('HH:mm')}
                                                                                />
                                                                            </ComposedChart>
                                                                        </ResponsiveContainer>
                                                                    ) : (
                                                                        <Typography align="center" color="text.secondary">
                                                                            No Voltage Harmonics data.
                                                                        </Typography>
                                                                    )}
                                                                </Box>
                                                            )}

                                                            {/* Current Harmonics Graph */}
                                                            {graphToggles?.current_harmonics && hasHarmonicsData(processedHarmonicsCurrent, ['harmonic_current_rate_a', 'harmonic_current_rate_b', 'harmonic_current_rate_c']) && (
                                                                <Box sx={{ width: '48%', height: 350, mb: 6 }}>
                                                                    <Typography
                                                                        variant="subtitle1"
                                                                        sx={{
                                                                            mb: 1,
                                                                            fontWeight: 600,
                                                                            textAlign: 'center',
                                                                            color: darkMode ? colors.f2 : colors.f3
                                                                        }}
                                                                    >
                                                                        Current Harmonics (%)
                                                                    </Typography>
                                                                    {processedHarmonicsCurrent?.length > 0 ? (
                                                                        <ResponsiveContainer width="100%" height="100%">
                                                                            <ComposedChart data={processedHarmonicsCurrent}>
                                                                                <CartesianGrid strokeDasharray="3 3" />

                                                                                <XAxis
                                                                                    dataKey="recorded_at"
                                                                                    ticks={meterHarmonicsCurrentTicks}
                                                                                    interval={0}
                                                                                    tickFormatter={(tick) => moment(tick).format('HH:mm')}
                                                                                    tick={{ fontSize: 12, fill: darkMode ? colors.f2 : colors.f3 }}
                                                                                    angle={-65}
                                                                                    textAnchor="end"
                                                                                    height={60}
                                                                                />

                                                                                <YAxis
                                                                                    tickFormatter={(value) => value.toFixed(2)}
                                                                                    label={{
                                                                                        value: 'THD (%)',
                                                                                        angle: -90,
                                                                                        position: 'insideLeft',
                                                                                        style: { fontSize: '0.6vw' },
                                                                                    }}
                                                                                    tick={{ fontSize: 12, fill: darkMode ? colors.f2 : colors.f3 }}
                                                                                />

                                                                                <Tooltip
                                                                                    formatter={(value, name) => [Number(value).toFixed(2), name]}
                                                                                    labelFormatter={(label) => `Time: ${moment(label).format('DD-MM-YYYY HH:mm')} `}
                                                                                />

                                                                                <Legend
                                                                                    verticalAlign="bottom"
                                                                                    height={36}
                                                                                    wrapperStyle={{ fontSize: '0.7vw' }}
                                                                                    onClick={(e) => SM_handleLegendClick(meter.serial_number, e.dataKey)}
                                                                                />

                                                                                <Line
                                                                                    type="monotone"
                                                                                    dataKey="harmonic_current_rate_a"
                                                                                    name="Current Harmonics A (%)"
                                                                                    stroke="#ff7300"
                                                                                    strokeWidth={2}
                                                                                    dot={false}
                                                                                    connectNulls
                                                                                    opacity={meterVisibility.harmonic_current_rate_a === false ? 0 : 1}
                                                                                />
                                                                                <Line
                                                                                    type="monotone"
                                                                                    dataKey="harmonic_current_rate_b"
                                                                                    name="Current Harmonics B (%)"
                                                                                    stroke="#ffc658"
                                                                                    strokeWidth={2}
                                                                                    dot={false}
                                                                                    connectNulls
                                                                                    opacity={meterVisibility.harmonic_current_rate_b === false ? 0 : 1}
                                                                                />
                                                                                <Line
                                                                                    type="monotone"
                                                                                    dataKey="harmonic_current_rate_c"
                                                                                    name="Current Harmonics C (%)"
                                                                                    stroke="#6394cc"
                                                                                    strokeWidth={2}
                                                                                    dot={false}
                                                                                    connectNulls
                                                                                    opacity={meterVisibility.harmonic_current_rate_c === false ? 0 : 1}
                                                                                />

                                                                                <Brush
                                                                                    dataKey="recorded_at"
                                                                                    height={20}
                                                                                    stroke={darkMode ? colors.g4 : '#8884d8'}
                                                                                    travellerWidth={10}
                                                                                    tickFormatter={(tick) => moment(tick).format('HH:mm')}
                                                                                />
                                                                            </ComposedChart>
                                                                        </ResponsiveContainer>
                                                                    ) : (
                                                                        <Typography align="center" color="text.secondary">
                                                                            No Current Harmonics data.
                                                                        </Typography>
                                                                    )}
                                                                </Box>
                                                            )}

                                                            {/* Building Load Percentage Graph */}
                                                            {graphToggles?.building_load &&
                                                                <Box sx={{ width: '48%', height: 350, mb: 6, }}>
                                                                    <Typography
                                                                        variant="subtitle1"
                                                                        sx={{
                                                                            mb: 1,
                                                                            fontWeight: 600,
                                                                            textAlign: 'center',
                                                                            color: darkMode ? colors.f2 : colors.f3
                                                                        }}
                                                                    >
                                                                        Building Load Percentage
                                                                    </Typography>

                                                                    {meter.percentage_graph && meter.percentage_graph.length > 0 ? (
                                                                        <ResponsiveContainer width="100%" height="100%">
                                                                            <LineChart data={meter.percentage_graph}>  {/* Use raw data directly */}
                                                                                <CartesianGrid strokeDasharray="3 3" />

                                                                                <XAxis
                                                                                    dataKey="recorded_at"
                                                                                    ticks={gridTicks}
                                                                                    interval={0}
                                                                                    tickFormatter={(tick) => moment(tick).format('HH:mm')}
                                                                                    tick={{ fontSize: 12, fill: darkMode ? colors.f2 : colors.f3 }}
                                                                                    angle={-65}
                                                                                    textAnchor="end"
                                                                                    height={60}
                                                                                />
                                                                                <YAxis
                                                                                    domain={[0, 100]}  // Percentage is 0-100
                                                                                    tickFormatter={(value) => {
                                                                                        // Format to 2 decimal places, but trim trailing .00
                                                                                        const formatted = Number(value).toFixed(2);
                                                                                        const trimmed = formatted.replace(/\.00$/, '');
                                                                                        return `${trimmed}% `;
                                                                                    }}
                                                                                    label={{
                                                                                        value: 'Percentage (%)',
                                                                                        angle: -90,
                                                                                        position: 'insideLeft',
                                                                                        style: { fontSize: '0.6vw' },
                                                                                    }}
                                                                                    tick={{ fontSize: 12, fill: darkMode ? colors.f2 : colors.f3 }}
                                                                                />

                                                                                <Tooltip
                                                                                    formatter={(value) => [`${Number(value).toFixed(2)}% `, 'Building Load']}
                                                                                    labelFormatter={(label) => `Time: ${moment(label).format('DD-MM-YYYY HH:mm')} `}
                                                                                />

                                                                                <Legend verticalAlign="bottom" height={36} />

                                                                                <Line
                                                                                    type="monotone"
                                                                                    dataKey="percentage"  // Use the percentage field from your data
                                                                                    name="Building Load Percentage"
                                                                                    stroke={darkMode ? colors.g1 : colors.g8}
                                                                                    strokeWidth={2}
                                                                                    dot={false}
                                                                                    connectNulls
                                                                                />

                                                                                <Brush
                                                                                    dataKey="recorded_at"
                                                                                    height={20}
                                                                                    stroke={darkMode ? colors.g4 : '#8884d8'}
                                                                                    travellerWidth={10}
                                                                                    tickFormatter={(tick) => moment(tick).format('HH:mm')}
                                                                                />
                                                                            </LineChart>
                                                                        </ResponsiveContainer>
                                                                    ) : (
                                                                        <Typography align="center" color="text.secondary">
                                                                            No Percentage data available.
                                                                        </Typography>
                                                                    )}
                                                                </Box>}

                                                        </Box>
                                                    </Box>

                                                </React.Fragment>
                                            );
                                        })}
                                    </Box>
                                )}

                            </Box>
                        ) : (
                            ""
                        )}
                    </div>

                    {/* ------------------------------------SOLAR------------------------------------------ */}
                    <div>
                        {isLoading ? (
                            <LoadingOverlay />
                        ) : smsolarData && smsolarData.length > 0 ? (
                            <Box sx={{ width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>

                                {/* Main Graph */}
                                <Box sx={{ width: '70%', height: { xs: 300, md: 500 }, mb: 5, mx: 'auto', mt: 2 }}>
                                    <Typography
                                        sx={{
                                            mb: 2,
                                            textAlign: 'center',
                                            color: darkMode ? colors.f2 : colors.f3,
                                            fontSize: '1.5rem',
                                            fontWeight: 'bold',
                                        }}
                                    >
                                        Solar Analysis
                                    </Typography>

                                    <ResponsiveContainer width="100%" height="100%">
                                        <LineChart data={getSolarChartData()}>
                                            <CartesianGrid strokeDasharray="3 3" stroke={darkMode ? colors.f2 : colors.f1} />

                                            <XAxis
                                                dataKey="recorded_at" // Change this to match your data key
                                                ticks={solarTicks}
                                                interval={0}
                                                tickFormatter={(time) => moment(time).format("HH:mm")}
                                                stroke={darkMode ? colors.f2 : colors.f3}
                                                tick={{ fill: darkMode ? colors.f2 : colors.f3, fontSize: 12 }}
                                                allowDuplicatedCategory={false}
                                                padding={{ right: 10 }} // Added left padding to fix the 00:00 alignment
                                            />

                                            <YAxis
                                                tick={{ fontSize: 12, fill: darkMode ? colors.f2 : colors.f3 }}
                                                label={{
                                                    value: 'Power (kW)',
                                                    angle: -90,
                                                    position: 'insideLeft',
                                                    offset: 10,
                                                    fill: darkMode ? colors.f2 : colors.f3,
                                                }}
                                            />

                                            <Tooltip
                                                formatter={(value, name) => [
                                                    value !== null && value !== undefined ? value.toFixed(2) : 'N/A',
                                                    name
                                                ]}
                                                labelFormatter={(label) => `Time: ${moment(label).format('DD-MM-YYYY HH:mm')} `}
                                                contentStyle={{
                                                    backgroundColor: darkMode ? 'rgba(0, 0, 25, 0.8)' : colors.f2,
                                                    color: darkMode ? colors.f2 : colors.f3,
                                                }}
                                            />

                                            <Legend />

                                            {/* Actual Solar Line */}
                                            <Line
                                                type="monotone"
                                                dataKey="total_active_power_kw"
                                                stroke={darkMode ? colors.g2 : colors.g10}
                                                strokeWidth={2}
                                                dot={{ r: 2, fill: darkMode ? colors.g2 : colors.g10 }}
                                                name="Actual Solar (kW)"
                                                connectNulls={true}
                                            />

                                            {(comparisonSolarData.length > 0 || solarComparisonAccumMax !== null) && (
                                                <Line
                                                    type="monotone"
                                                    dataKey="comparison_power_kw"
                                                    stroke={getSolarComparisonColor()}
                                                    strokeWidth={2}
                                                    dot={false}
                                                    name={`${getSolarComparisonLabel()} (kW)`}
                                                    connectNulls={true}
                                                />
                                            )}

                                        </LineChart>
                                    </ResponsiveContainer>
                                </Box>

                                {/* Expand/Collapse Button in its own Box below the main graph */}
                                <Box
                                    sx={{
                                        width: '80%',
                                        mx: 'auto',
                                        mt: 5,
                                        mb: 2,
                                        display: 'flex',
                                        justifyContent: 'center',
                                        gap: 2,
                                    }}
                                >
                                    <Button variant="outlined" onClick={() => setExpandedsolar(!expandedsolar)}
                                        sx={{
                                            backgroundColor: darkMode ? colors.d4 : colors.l4,
                                            width: "160px",
                                            height: "50px",
                                            fontSize: "14px",
                                            position: "relative",
                                            zIndex: 1,
                                            color: colors.f2,
                                        }}>
                                        {expandedsolar ? 'Collapse Details' : 'Expand Details'}
                                    </Button>

                                    {/* Solar Compare Button */}
                                    <Button
                                        id="solar-compare-button"
                                        variant="outlined"
                                        onClick={handleSolarClick}
                                        sx={{
                                            color: darkMode ? colors.f2 : colors.f3,
                                            borderColor: darkMode ? colors.f2 : colors.f3,
                                            '&:hover': {
                                                borderColor: darkMode ? colors.g4 : colors.g1,
                                                backgroundColor: darkMode ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.05)'
                                            }
                                        }}
                                    >
                                        Compare {solarComparisonType && `(${getSolarComparisonLabel()})`}
                                    </Button>

                                    <Menu
                                        anchorEl={solarAnchorEl}
                                        open={solarOpen}
                                        onClose={handleSolarClose}
                                        anchorOrigin={{
                                            vertical: 'bottom',
                                            horizontal: 'left',
                                        }}
                                        transformOrigin={{
                                            vertical: 'top',
                                            horizontal: 'left',
                                        }}
                                        PaperProps={{
                                            elevation: 3,
                                            sx: {
                                                mt: 1,
                                                minWidth: 220,
                                                borderRadius: 2,
                                                overflow: 'hidden',
                                                backgroundColor: darkMode ? colors.bg : 'white',
                                                color: darkMode ? colors.f2 : colors.f3,
                                                boxShadow: '0 6px 18px rgba(0,0,0,0.12)',
                                            }
                                        }}
                                    >
                                        {/* Clear Comparison */}
                                        {solarComparisonType && (
                                            <>
                                                <MenuItem
                                                    onClick={() => {
                                                        clearSolarComparison();
                                                        handleSolarClose();
                                                    }}
                                                    sx={{
                                                        px: 2,
                                                        py: 1,
                                                        color: 'error.main',
                                                        '&:hover': {
                                                            backgroundColor: 'rgba(255,0,0,0.08)',
                                                        }
                                                    }}
                                                >
                                                    Clear Comparison
                                                </MenuItem>

                                                <Divider />
                                            </>
                                        )}

                                        {/* Options */}
                                        {[
                                            { label: 'Yesterday', value: 'yesterday' },
                                            { label: 'Same Day Last Week', value: 'sameDayLastWeek' },
                                            { label: 'Last Week Average', value: 'lastWeekAvg' },
                                            { label: 'Last Month Average', value: 'lastMonthAvg' },
                                            { label: 'Last Year Average', value: 'lastYearAvg' },
                                            // { label: 'Accumulated Max', value: 'accumMax' },
                                        ].map((item) => {
                                            const isSelected = solarComparisonType === item.value;

                                            return (
                                                <MenuItem
                                                    key={item.value}
                                                    onClick={() => {
                                                        handleSolarCompare(item.value);
                                                        handleSolarClose();
                                                    }}
                                                    sx={{
                                                        px: 2,
                                                        py: 1,
                                                        borderLeft: isSelected
                                                            ? `3px solid ${darkMode ? colors.g4 : '#1976d2'} `
                                                            : '3px solid transparent',
                                                        backgroundColor: isSelected
                                                            ? (darkMode
                                                                ? 'rgba(255,255,255,0.06)'
                                                                : 'rgba(25,118,210,0.06)')
                                                            : 'transparent',
                                                        '&:hover': {
                                                            backgroundColor: darkMode
                                                                ? 'rgba(255,255,255,0.1)'
                                                                : 'rgba(0,0,0,0.05)',
                                                        },
                                                    }}
                                                >
                                                    {item.label}
                                                </MenuItem>
                                            );
                                        })}
                                    </Menu>
                                </Box>

                                {/* Show all meters only if expanded */}
                                {expandedsolar && (
                                    <Box
                                        sx={{
                                            display: 'flex',
                                            flexWrap: 'wrap',
                                            gap: 3,
                                            mx: 'auto',
                                            width: '75%',
                                        }}
                                    >
                                        {mergedsolarMeters.map((meter, index) => {
                                            // Find the corresponding NEMA data for this solar meter
                                            const nemaMeter = nemaUnbalanceSolar.find(n => n.serial_number === meter.serial_number);

                                            const maxUnbalance = Number(
                                                Math.max(
                                                    ...(nemaMeter?.data.map(d => d.nema_unbalanced_pct) || [0]),
                                                    0.5
                                                ).toFixed(2)
                                            );

                                            const nemaMetercurrent = nemaUnbalanceSolarCurrent.find(n => n.serial_number === meter.serial_number);

                                            const maxUnbalancecurrent = Number(
                                                Math.max(
                                                    ...(nemaMetercurrent?.data.map(d => d.nema_unbalanced_pct) || [0]),
                                                    0.5
                                                ).toFixed(2)
                                            );

                                            const nemaMeterpower = nemaUnbalanceSolarPower.find(n => n.serial_number === meter.serial_number);

                                            const maxUnbalancepower = Number(
                                                Math.max(
                                                    ...(nemaMeterpower?.data.map(d => d.nema_unbalanced_pct) || [0]),
                                                    0.5
                                                ).toFixed(2)
                                            );


                                            // Dynamic voltage min/max for left Y-axis
                                            const voltageValues = meter.nemaData?.flatMap(d => [d.voltage_r, d.voltage_y, d.voltage_b]) || [];
                                            const minVoltage = voltageValues.length > 0 ? Math.min(...voltageValues) : 0;
                                            const maxVoltage = voltageValues.length > 0 ? Math.max(...voltageValues) : 250;
                                            const power = (meter.serial_number) || { active_power_a_kw: false, active_power_b_kw: false, active_power_c_kw: false };
                                            const meterVisibility = visibleLines[meter.serial_number] || {
                                                voltage_an_v: false,
                                                voltage_bn_v: false,
                                                voltage_cn_v: false,
                                                current_a_a: false,
                                                current_b_a: false,
                                                current_c_a: false,
                                                // active_power_a_kw: false,
                                                // active_power_b_kw: false,
                                                // active_power_c_kw: false,
                                            };

                                            const processedsolarData = meter.nemaData?.map((d) => ({
                                                ...d,
                                                Unbalanced: d.nema_unbalanced_pct > 1
                                                    ? Number(d.nema_unbalanced_pct.toFixed(2))
                                                    : null,
                                            })) || [];

                                            const processedsolarDatacurrent = nemaMetercurrent?.data.map((d) => ({
                                                ...d,
                                                Unbalanced: d.nema_unbalanced_pct > 10
                                                    ? Number(d.nema_unbalanced_pct.toFixed(2))
                                                    : null,
                                            })) || [];

                                            const processedsolarDatapower = nemaMeterpower?.data.map((d) => ({
                                                ...d,
                                                Unbalanced: d.nema_unbalanced_pct > 10
                                                    ? Number(d.nema_unbalanced_pct.toFixed(2))
                                                    : null,
                                            })) || [];

                                            const processedSolarPFData = meter.nemaData?.map((d) => ({
                                                ...d,
                                                total_pf: d.total_pf !== null ? Number(d.total_pf.toFixed(2)) : null,
                                                low_pf: d.total_pf < 0.9 ? d.total_pf : null, // optional highlight
                                            })) || [];

                                            const solarPowerKVAData = meter.nemaData?.map((d) => ({
                                                ...d,
                                                total_apparent_power_kva: d.total_apparent_power_kva !== null ? Number(d.total_apparent_power_kva.toFixed(2)) : null,
                                            })) || [];


                                            // Find the corresponding Harmonics Voltage data for this meter
                                            const harmonicsVoltageMeter = (harmonicsVoltage_solar || []).find(n => n.serial_number === meter.serial_number);
                                            const processedHarmonicsVoltage = harmonicsVoltageMeter?.data.map((d) => ({
                                                ...d,
                                                harmonic_voltage_rate_a: d.harmonic_voltage_rate_a !== null ? Number(d.harmonic_voltage_rate_a.toFixed(2)) : null,
                                                harmonic_voltage_rate_b: d.harmonic_voltage_rate_b !== null ? Number(d.harmonic_voltage_rate_b.toFixed(2)) : null,
                                                harmonic_voltage_rate_c: d.harmonic_voltage_rate_c !== null ? Number(d.harmonic_voltage_rate_c.toFixed(2)) : null,
                                            }));

                                            // Find the corresponding Harmonics Current data for this meter
                                            const harmonicsCurrentMeter = (harmonicsCurrent_solar || []).find(n => n.serial_number === meter.serial_number);
                                            const processedHarmonicsCurrent = harmonicsCurrentMeter?.data.map((d) => ({
                                                ...d,
                                                harmonic_current_rate_a: d.harmonic_current_rate_a !== null ? Number(d.harmonic_current_rate_a.toFixed(2)) : null,
                                                harmonic_current_rate_b: d.harmonic_current_rate_b !== null ? Number(d.harmonic_current_rate_b.toFixed(2)) : null,
                                                harmonic_current_rate_c: d.harmonic_current_rate_c !== null ? Number(d.harmonic_current_rate_c.toFixed(2)) : null,
                                            }));


                                            const getHourTicks = (data, timeKey = 'recorded_at') => {
                                                if (!data || data.length === 0) return [];

                                                const seen = new Set();
                                                return data.reduce((ticks, d) => {
                                                    const time = d[timeKey];
                                                    if (!time || seen.has(time)) return ticks;

                                                    const m = moment(time);
                                                    if (m.isValid() && m.minute() === 0 && m.second() === 0) {
                                                        seen.add(time);
                                                        ticks.push(time);
                                                    }
                                                    return ticks;
                                                }, []);
                                            };


                                            const meterSolarTicks = getHourTicks(meter.data);
                                            const meterNemaTicks = getHourTicks(processedsolarData);
                                            const meterCurrentTicks = getHourTicks(processedsolarDatacurrent);
                                            const meterPowerTicks = getHourTicks(processedsolarDatapower);
                                            const meterPFTicks = getHourTicks(processedSolarPFData);
                                            const meterKVATicks = getHourTicks(solarPowerKVAData);
                                            const meterHarmonicsVoltageTicks = getHourTicks(processedHarmonicsVoltage);
                                            const meterHarmonicsCurrentTicks = getHourTicks(processedHarmonicsCurrent);

                                            const hasHarmonicsData = (data, keys) =>
                                                data?.some(row => keys.some(key => row[key] !== null));



                                            return (
                                                <React.Fragment key={index}>
                                                    {/* Meter Card */}
                                                    <Box
                                                        sx={{
                                                            width: '100%',
                                                            mt: 3,
                                                            p: 2,
                                                            backgroundColor: darkMode ? 'rgba(255,255,255,0.05)' : '#f9f9f967',
                                                            borderRadius: '12px',
                                                            boxShadow: darkMode
                                                                ? '0 0 10px rgba(255,255,255,0.1)'
                                                                : '0 0 10px rgba(0,0,0,0.1)',
                                                        }}
                                                    >
                                                        <Typography
                                                            align="center"
                                                            gutterBottom
                                                            sx={{
                                                                color: darkMode ? colors.f2 : colors.f3,
                                                                fontSize: '1.2rem',
                                                            }}
                                                        >
                                                            Solar Consumption{' '}
                                                            {accessLevel === 3 && missingPercentagesSolar[meter.serial_number] !== undefined && (
                                                                <Box
                                                                    component="span"
                                                                    sx={{
                                                                        fontSize: '1rem',
                                                                        color: "red",
                                                                    }}
                                                                >
                                                                    (Missing Data: {missingPercentagesSolar[meter.serial_number]}%)
                                                                </Box>
                                                            )}
                                                        </Typography>

                                                        <Box
                                                            sx={{
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                justifyContent: 'center',
                                                                gap: '2.5%',
                                                                mb: 1,
                                                            }}
                                                        >
                                                            <Typography
                                                                sx={{
                                                                    fontWeight: 'bold',
                                                                    color: darkMode ? colors.f2 : colors.f3,
                                                                    fontSize: '1.2rem',
                                                                }}
                                                            >
                                                                Smart Meter: {meter.serial_number}
                                                            </Typography>
                                                            <Box
                                                                sx={{
                                                                    width: '1.2vw',
                                                                    height: '2vh',
                                                                    borderRadius: '3vw',
                                                                    backgroundColor: meterStatusessolar[index] ? 'green' : 'red',
                                                                    position: 'relative',
                                                                    transition: 'background-color 0.3s',
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    px: '1.6%',
                                                                }}
                                                            >
                                                                <Box
                                                                    sx={{
                                                                        width: '0.8vw',
                                                                        height: '0.8vw',
                                                                        borderRadius: '50%',
                                                                        backgroundColor: 'white',
                                                                        position: 'absolute',
                                                                        left: meterStatusessolar[index] ? '52%' : '10%',
                                                                        transition: 'left 0.3s',
                                                                    }}
                                                                />
                                                            </Box>
                                                        </Box>

                                                        <Box
                                                            sx={{
                                                                height: "auto",
                                                                width: "auto",
                                                                display: "flex",
                                                                justifyContent: "center",
                                                                alignItems: "center",
                                                                flexDirection: "row",
                                                                gap: "3%",
                                                            }}
                                                        >
                                                            <Typography
                                                                align="center"
                                                                gutterBottom
                                                                sx={{
                                                                    color: darkMode ? colors.f2 : colors.f3,
                                                                    fontSize: '1.1rem',
                                                                    display: "flex",
                                                                    alignItems: "center",
                                                                }}
                                                            >
                                                                Description: {meter.description}

                                                                <MuiTooltip
                                                                    title="To view the voltage data, simply click the label below the graph."
                                                                    placement="right"
                                                                    arrow
                                                                >
                                                                    <HelpOutlineIcon
                                                                        sx={{
                                                                            fontSize: '1rem',
                                                                            cursor: 'pointer',
                                                                            ml: 0.5,
                                                                            color: colors.f1,
                                                                        }}
                                                                    />
                                                                </MuiTooltip>
                                                            </Typography>
                                                        </Box>

                                                        <Box sx={{ display: 'flex', justifyContent: 'center', flexWrap: 'wrap', mt: 4, gap: 2 }}>
                                                            {/* Solar Generation graph */}
                                                            {graphToggles?.consumption && (
                                                                meter.data?.length > 0 ? (
                                                                    <Box sx={{ width: '48%', height: 350, mb: 6 }}>
                                                                        <Typography
                                                                            variant="subtitle1"
                                                                            sx={{
                                                                                mb: 1,
                                                                                fontWeight: 600,
                                                                                textAlign: 'center',
                                                                                color: darkMode ? colors.f2 : colors.f3
                                                                            }}
                                                                        >
                                                                            Solar Generation (kW)
                                                                        </Typography>
                                                                        <ResponsiveContainer width="100%" height="100%">
                                                                            <LineChart data={meter.data}>
                                                                                <CartesianGrid
                                                                                    strokeDasharray="3 3"
                                                                                    stroke={darkMode ? colors.f2 : colors.f1}
                                                                                />
                                                                                <XAxis
                                                                                    dataKey="recorded_at"
                                                                                    ticks={meterSolarTicks}
                                                                                    interval={0}
                                                                                    tickFormatter={(tick) => moment(tick).format('HH:mm')}
                                                                                    tick={{ fontSize: 12, fill: darkMode ? colors.f2 : colors.f3 }}
                                                                                    angle={-65}
                                                                                    textAnchor="end"
                                                                                    height={60}
                                                                                />
                                                                                <YAxis
                                                                                    tick={{ fontSize: 12, fill: darkMode ? colors.f2 : colors.f3 }}
                                                                                    label={{
                                                                                        value: 'Power (kW)',
                                                                                        angle: -90,
                                                                                        position: 'insideLeft',
                                                                                        offset: 10,
                                                                                        fill: darkMode ? colors.f2 : colors.f3,
                                                                                    }}
                                                                                />
                                                                                <Tooltip
                                                                                    formatter={(v) => [v.toFixed(2), 'Solar Generation (kW)']}
                                                                                    labelFormatter={(label) =>
                                                                                        `Time: ${moment(label).format('DD-MM-YYYY HH:mm')} `
                                                                                    }
                                                                                    contentStyle={{
                                                                                        backgroundColor: darkMode ? 'rgba(0, 0, 25, 0.8)' : colors.f2,
                                                                                        color: darkMode ? colors.f2 : colors.f3,
                                                                                    }}
                                                                                />
                                                                                <Legend verticalAlign="bottom" height={36} />
                                                                                <Line
                                                                                    type="monotone"
                                                                                    dataKey="total_active_power_kw"
                                                                                    stroke={darkMode ? colors.g2 : colors.g10}
                                                                                    strokeWidth={2}
                                                                                    dot={{ r: 2, fill: darkMode ? colors.g2 : colors.g10 }}
                                                                                    animationDuration={1000}
                                                                                    name="Solar Generation (kW)"
                                                                                    connectNulls
                                                                                />
                                                                            </LineChart>
                                                                        </ResponsiveContainer>
                                                                    </Box>
                                                                ) : (
                                                                    <Box sx={{ width: '48%', height: 350, mb: 6 }}>
                                                                        <Typography
                                                                            variant="subtitle1"
                                                                            sx={{
                                                                                mb: 1,
                                                                                fontWeight: 600,
                                                                                textAlign: 'center',
                                                                                color: darkMode ? colors.f2 : colors.f3
                                                                            }}
                                                                        >
                                                                            Solar Generation (kW)
                                                                        </Typography>
                                                                        <Typography align="center" color="text.secondary">
                                                                            No data available for graph.
                                                                        </Typography>
                                                                    </Box>
                                                                )
                                                            )}

                                                            {/* Solar Power Phase Unbalance graph */}
                                                            {graphToggles?.phase_diff_kw &&
                                                                <Box sx={{ width: '48%', height: 350, mb: 6 }}>
                                                                    <Typography
                                                                        variant="subtitle1"
                                                                        sx={{
                                                                            mb: 1,
                                                                            fontWeight: 600,
                                                                            textAlign: 'center',
                                                                            color: darkMode ? colors.f2 : colors.f3
                                                                        }}
                                                                    >
                                                                        Phase difference (kW)
                                                                    </Typography>
                                                                    {processedsolarDatapower?.length > 0 ? (
                                                                        <ResponsiveContainer width="100%" height="100%">
                                                                            <ComposedChart data={processedsolarDatapower}>
                                                                                <CartesianGrid strokeDasharray="3 3" />

                                                                                <XAxis
                                                                                    dataKey="recorded_at"
                                                                                    ticks={meterPowerTicks}
                                                                                    interval={0}
                                                                                    tickFormatter={(tick) => moment(tick).format('HH:mm')}
                                                                                    tick={{ fontSize: 12, fill: darkMode ? colors.f2 : colors.f3 }}
                                                                                    angle={-65}
                                                                                    textAnchor="end"
                                                                                    height={60}
                                                                                />

                                                                                <YAxis
                                                                                    yAxisId="left"
                                                                                    domain={[minVoltage, maxVoltage + 5]}
                                                                                    tickFormatter={(value) => value.toFixed(1)}
                                                                                    label={{
                                                                                        value: 'Active Power (kW)',
                                                                                        angle: -90,
                                                                                        position: 'insideLeft',
                                                                                        style: { fontSize: '0.6vw' },
                                                                                    }}
                                                                                    tick={{ fontSize: 12, fill: darkMode ? colors.f2 : colors.f3 }}
                                                                                />

                                                                                <YAxis
                                                                                    yAxisId="right"
                                                                                    orientation="right"
                                                                                    domain={[0, maxUnbalancepower + 0.1]}
                                                                                    label={{
                                                                                        value: 'Unbalanced (%)',
                                                                                        angle: -90,
                                                                                        position: 'insideRight',
                                                                                        style: { fontSize: '0.6vw' },
                                                                                    }}
                                                                                    tickFormatter={(value) => value.toFixed(2)}
                                                                                    tick={{ fontSize: 12, fill: darkMode ? colors.f2 : colors.f3 }}
                                                                                />

                                                                                <Tooltip
                                                                                    formatter={(value, name) => [Number(value).toFixed(2), name]}
                                                                                    labelFormatter={(label) => `Time: ${moment(label).format('DD-MM-YYYY HH:mm')} `}
                                                                                />
                                                                                <Legend
                                                                                    verticalAlign="bottom"
                                                                                    height={36}
                                                                                    wrapperStyle={{ fontSize: '0.7vw' }}
                                                                                    onClick={(e) => SM_handleLegendClick(meter.serial_number, e.dataKey)}
                                                                                    formatter={(value) => (value === 'Unbalanced' ? null : value)}
                                                                                />

                                                                                {/* <Area
                                                                                yAxisId="right"
                                                                                type="monotone"
                                                                                dataKey="nema_unbalanced_pct"
                                                                                name="NEMA Power Unbalanced (%)"
                                                                                fill="#74b800"
                                                                                stroke="#74b800"
                                                                                strokeWidth={2}
                                                                                fillOpacity={0.3}
                                                                                connectNulls
                                                                            /> */}

                                                                                <Line
                                                                                    yAxisId="left"
                                                                                    type="monotone"
                                                                                    dataKey="active_power_a_kw"
                                                                                    name="Active Power A (kW)"
                                                                                    stroke="#ff7300"
                                                                                    strokeWidth={2}
                                                                                    dot={false}
                                                                                    connectNulls
                                                                                    opacity={power.active_power_a_kw === false ? 0 : 1}
                                                                                />
                                                                                <Line
                                                                                    yAxisId="left"
                                                                                    type="monotone"
                                                                                    dataKey="active_power_b_kw"
                                                                                    name="Active Power B (kW)"
                                                                                    stroke="#ffc658"
                                                                                    strokeWidth={2}
                                                                                    dot={false}
                                                                                    connectNulls
                                                                                    opacity={power.active_power_b_kw === false ? 0 : 1}
                                                                                />
                                                                                <Line
                                                                                    yAxisId="left"
                                                                                    type="monotone"
                                                                                    dataKey="active_power_c_kw"
                                                                                    name="Active Power C (kW)"
                                                                                    stroke="#6394cc"
                                                                                    strokeWidth={2}
                                                                                    dot={false}
                                                                                    connectNulls
                                                                                    opacity={power.active_power_c_kw === false ? 0 : 1}
                                                                                />

                                                                                <Brush
                                                                                    dataKey="recorded_at"
                                                                                    height={20}
                                                                                    stroke={darkMode ? colors.g4 : '#8884d8'}
                                                                                    travellerWidth={10}
                                                                                    tickFormatter={(tick) => moment(tick).format('HH:mm')}
                                                                                />
                                                                            </ComposedChart>
                                                                        </ResponsiveContainer>
                                                                    ) : (
                                                                        <Typography align="center" color="text.secondary">
                                                                            No Power Phase Unbalance data.
                                                                        </Typography>
                                                                    )}
                                                                </Box>}

                                                            {/* Solar Voltage Unbalanced graph */}
                                                            {graphToggles?.phase_diff_voltage &&
                                                                <Box sx={{ width: '48%', height: 350, mb: 6 }}>
                                                                    <Typography
                                                                        variant="subtitle1"
                                                                        sx={{
                                                                            mb: 1,
                                                                            fontWeight: 600,
                                                                            textAlign: 'center',
                                                                            color: darkMode ? colors.f2 : colors.f3
                                                                        }}
                                                                    >
                                                                        Phase difference (V)
                                                                    </Typography>
                                                                    {meter.nemaData?.length > 0 ? (
                                                                        <ResponsiveContainer width="100%" height="100%">
                                                                            <ComposedChart data={processedsolarData}>
                                                                                <CartesianGrid strokeDasharray="3 3" />

                                                                                <XAxis
                                                                                    dataKey="recorded_at"
                                                                                    ticks={meterNemaTicks}
                                                                                    interval={0}
                                                                                    tickFormatter={(tick) => moment(tick).format('HH:mm')}
                                                                                    tick={{ fontSize: 12, fill: darkMode ? colors.f2 : colors.f3 }}
                                                                                    angle={-65}
                                                                                    textAnchor="end"
                                                                                    height={60}
                                                                                />

                                                                                <YAxis
                                                                                    yAxisId="left"
                                                                                    domain={[minVoltage, maxVoltage + 5]}
                                                                                    tickFormatter={(value) => value.toFixed(1)}
                                                                                    label={{ value: 'Voltage (V)', angle: -90, position: 'insideLeft', style: { fontSize: '0.6vw' }, dx: -5, }}
                                                                                />

                                                                                <YAxis
                                                                                    yAxisId="right"
                                                                                    orientation="right"
                                                                                    domain={[0, maxUnbalance + 0.1]}
                                                                                    tickFormatter={(value) => value.toFixed(2)}
                                                                                    label={{
                                                                                        value: 'Unbalanced (%)',
                                                                                        angle: -90,
                                                                                        position: 'insideRight',
                                                                                        style: { fontSize: '0.6vw' },
                                                                                    }}
                                                                                />

                                                                                <Tooltip
                                                                                    formatter={(value, name) => [Number(value).toFixed(2), name]}
                                                                                    labelFormatter={(label) => `Time: ${moment(label).format('DD-MM-YYYY HH:mm')} `}
                                                                                />

                                                                                <Legend
                                                                                    verticalAlign="bottom"
                                                                                    height={36}
                                                                                    wrapperStyle={{ fontSize: '0.7vw' }}
                                                                                    onClick={(e) => SM_handleLegendClick(meter.serial_number, e.dataKey)}
                                                                                    formatter={(value) => (value === 'Unbalanced' ? null : value)}
                                                                                />

                                                                                <Area
                                                                                    yAxisId="right"
                                                                                    type="monotone"
                                                                                    dataKey="nema_unbalanced_pct"
                                                                                    name="NEMA Unbalanced (%)"
                                                                                    fill="#74b800"
                                                                                    stroke="#74b800"
                                                                                    strokeWidth={2}
                                                                                    fillOpacity={0.3}
                                                                                    connectNulls
                                                                                />

                                                                                <Area
                                                                                    yAxisId="right"
                                                                                    type="monotone"
                                                                                    dataKey="Unbalanced"
                                                                                    name=""
                                                                                    fill="red"
                                                                                    stroke="red"
                                                                                    strokeWidth={2}
                                                                                    fillOpacity={0.5}
                                                                                    connectNulls={false}
                                                                                    legendType="none"
                                                                                />

                                                                                <Line
                                                                                    yAxisId="left"
                                                                                    type="monotone"
                                                                                    dataKey="voltage_an_v"
                                                                                    name="Voltage AN (V)"
                                                                                    stroke="#ff7300"
                                                                                    strokeWidth={2}
                                                                                    dot={false}
                                                                                    connectNulls
                                                                                    opacity={meterVisibility.voltage_an_v === false ? 0 : 1}
                                                                                />
                                                                                <Line
                                                                                    yAxisId="left"
                                                                                    type="monotone"
                                                                                    dataKey="voltage_bn_v"
                                                                                    name="Voltage BN (V)"
                                                                                    stroke="#ffc658"
                                                                                    strokeWidth={2}
                                                                                    dot={false}
                                                                                    connectNulls
                                                                                    opacity={meterVisibility.voltage_bn_v === false ? 0 : 1}
                                                                                />
                                                                                <Line
                                                                                    yAxisId="left"
                                                                                    type="monotone"
                                                                                    dataKey="voltage_cn_v"
                                                                                    name="Voltage CN (V)"
                                                                                    stroke="#6394cc"
                                                                                    strokeWidth={2}
                                                                                    dot={false}
                                                                                    connectNulls
                                                                                    opacity={meterVisibility.voltage_cn_v === false ? 0 : 1}
                                                                                />

                                                                                <Brush
                                                                                    dataKey="recorded_at"
                                                                                    height={20}
                                                                                    stroke={darkMode ? colors.g4 : '#8884d8'}
                                                                                    travellerWidth={10}
                                                                                    tickFormatter={(tick) => moment(tick).format('HH:mm')}
                                                                                />
                                                                            </ComposedChart>
                                                                        </ResponsiveContainer>
                                                                    ) : (
                                                                        <Typography align="center" color="text.secondary">
                                                                            No NEMA data.
                                                                        </Typography>
                                                                    )}
                                                                </Box>}

                                                            {/* Solar Current Phase Unbalance graph */}
                                                            {graphToggles?.phase_diff_current &&
                                                                <Box sx={{ width: '48%', height: 350, mb: 6 }}>
                                                                    <Typography
                                                                        variant="subtitle1"
                                                                        sx={{
                                                                            mb: 1,
                                                                            fontWeight: 600,
                                                                            textAlign: 'center',
                                                                            color: darkMode ? colors.f2 : colors.f3
                                                                        }}
                                                                    >
                                                                        Phase difference (A)
                                                                    </Typography>
                                                                    {nemaUnbalanceSolarCurrent?.length > 0 ? (
                                                                        <ResponsiveContainer width="100%" height="100%">
                                                                            <ComposedChart data={processedsolarDatacurrent}>
                                                                                <CartesianGrid strokeDasharray="3 3" />

                                                                                <XAxis
                                                                                    dataKey="recorded_at"
                                                                                    ticks={meterCurrentTicks}
                                                                                    interval={0}
                                                                                    tickFormatter={(tick) => moment(tick).format('HH:mm')}
                                                                                    tick={{ fontSize: 12, fill: darkMode ? colors.f2 : colors.f3 }}
                                                                                    angle={-65}
                                                                                    textAnchor="end"
                                                                                    height={60}
                                                                                />

                                                                                <YAxis
                                                                                    yAxisId="left"
                                                                                    domain={[minVoltage, maxVoltage + 5]}
                                                                                    label={{
                                                                                        value: 'Current (A)',
                                                                                        angle: -90,
                                                                                        position: 'insideLeft',
                                                                                        style: { fontSize: '0.6vw' },
                                                                                    }}
                                                                                    tickFormatter={(value) => value.toFixed(1)}
                                                                                    tick={{ fontSize: 12, fill: darkMode ? colors.f2 : colors.f3 }}
                                                                                />

                                                                                <YAxis
                                                                                    yAxisId="right"
                                                                                    orientation="right"
                                                                                    domain={[0, maxUnbalancecurrent + 1]}
                                                                                    label={{
                                                                                        value: 'Unbalanced (%)',
                                                                                        angle: -90,
                                                                                        position: 'insideRight',
                                                                                        style: { fontSize: '0.6vw' },
                                                                                    }}
                                                                                    tickFormatter={(value) => value.toFixed(2)}
                                                                                    tick={{ fontSize: 12, fill: darkMode ? colors.f2 : colors.f3 }}
                                                                                />

                                                                                <Tooltip
                                                                                    formatter={(value, name) => [Number(value).toFixed(2), name]}
                                                                                    labelFormatter={(label) => `Time: ${moment(label).format('DD-MM-YYYY HH:mm')} `}
                                                                                />
                                                                                <Legend
                                                                                    verticalAlign="bottom"
                                                                                    height={36}
                                                                                    wrapperStyle={{ fontSize: '0.7vw' }}
                                                                                    onClick={(e) => SM_handleLegendClick(meter.serial_number, e.dataKey)}
                                                                                    formatter={(value) => (value === 'Unbalanced' ? null : value)}
                                                                                />

                                                                                <Area
                                                                                    yAxisId="right"
                                                                                    type="monotone"
                                                                                    dataKey="nema_unbalanced_pct"
                                                                                    name="NEMA Current Unbalanced (%)"
                                                                                    fill="#74b800"
                                                                                    stroke="#74b800"
                                                                                    strokeWidth={2}
                                                                                    fillOpacity={0.3}
                                                                                    connectNulls
                                                                                />

                                                                                <Area
                                                                                    yAxisId="right"
                                                                                    type="monotone"
                                                                                    dataKey="Unbalanced"
                                                                                    name=""
                                                                                    fill="red"
                                                                                    stroke="red"
                                                                                    strokeWidth={2}
                                                                                    fillOpacity={0.5}
                                                                                    connectNulls={false}
                                                                                    legendType="none"
                                                                                />

                                                                                <Line
                                                                                    yAxisId="left"
                                                                                    type="monotone"
                                                                                    dataKey="current_a_a"
                                                                                    name="Current A (A)"
                                                                                    stroke="#ff7300"
                                                                                    strokeWidth={2}
                                                                                    dot={false}
                                                                                    connectNulls
                                                                                    opacity={meterVisibility.current_a_a === false ? 0 : 1}
                                                                                />
                                                                                <Line
                                                                                    yAxisId="left"
                                                                                    type="monotone"
                                                                                    dataKey="current_b_a"
                                                                                    name="Current B (A)"
                                                                                    stroke="#ffc658"
                                                                                    strokeWidth={2}
                                                                                    dot={false}
                                                                                    connectNulls
                                                                                    opacity={meterVisibility.current_b_a === false ? 0 : 1}
                                                                                />
                                                                                <Line
                                                                                    yAxisId="left"
                                                                                    type="monotone"
                                                                                    dataKey="current_c_a"
                                                                                    name="Current C (A)"
                                                                                    stroke="#6394cc"
                                                                                    strokeWidth={2}
                                                                                    dot={false}
                                                                                    connectNulls
                                                                                    opacity={meterVisibility.current_c_a === false ? 0 : 1}
                                                                                />

                                                                                <Brush
                                                                                    dataKey="recorded_at"
                                                                                    height={20}
                                                                                    stroke={darkMode ? colors.g4 : '#8884d8'}
                                                                                    travellerWidth={10}
                                                                                    tickFormatter={(tick) => moment(tick).format('HH:mm')}
                                                                                />
                                                                            </ComposedChart>
                                                                        </ResponsiveContainer>
                                                                    ) : (
                                                                        <Typography align="center" color="text.secondary">
                                                                            No Current Phase Unbalance data.
                                                                        </Typography>
                                                                    )}
                                                                </Box>}

                                                            {/* Solar Power Factor Graph */}
                                                            {graphToggles?.power_factor &&
                                                                <Box sx={{ width: '48%', height: 350, mb: 6 }}>
                                                                    <Typography
                                                                        variant="subtitle1"
                                                                        sx={{
                                                                            mb: 1,
                                                                            fontWeight: 600,
                                                                            textAlign: 'center',
                                                                            color: darkMode ? colors.f2 : colors.f3
                                                                        }}
                                                                    >
                                                                        Power Factor
                                                                    </Typography>
                                                                    {processedSolarPFData?.length > 0 ? (
                                                                        <ResponsiveContainer width="100%" height="100%">
                                                                            <LineChart data={processedSolarPFData}>
                                                                                <CartesianGrid strokeDasharray="3 3" />

                                                                                <XAxis
                                                                                    dataKey="recorded_at"
                                                                                    ticks={meterPFTicks}
                                                                                    interval={0}
                                                                                    tickFormatter={(tick) => moment(tick).format('HH:mm')}
                                                                                    tick={{ fontSize: 12, fill: darkMode ? colors.f2 : colors.f3 }}
                                                                                    angle={-65}
                                                                                    textAnchor="end"
                                                                                    height={60}
                                                                                />

                                                                                <YAxis
                                                                                    domain={[0, 1]}
                                                                                    tickFormatter={(value) => value.toFixed(2)}
                                                                                    label={{
                                                                                        value: 'Power Factor (PF)',
                                                                                        angle: -90,
                                                                                        position: 'insideLeft',
                                                                                        style: { fontSize: '0.6vw' },
                                                                                    }}
                                                                                    tick={{ fontSize: 12, fill: darkMode ? colors.f2 : colors.f3 }}
                                                                                />

                                                                                <Tooltip
                                                                                    formatter={(value) => [Number(value).toFixed(2), 'Total PF']}
                                                                                    labelFormatter={(label) =>
                                                                                        `Time: ${moment(label).format('DD-MM-YYYY HH:mm')} `
                                                                                    }
                                                                                    contentStyle={{
                                                                                        backgroundColor: darkMode
                                                                                            ? 'rgba(0, 0, 25, 0.8)'
                                                                                            : colors.f2,
                                                                                        color: darkMode ? colors.f2 : colors.f3,
                                                                                    }}
                                                                                />

                                                                                <Legend
                                                                                    verticalAlign="bottom"
                                                                                    height={36}
                                                                                />

                                                                                <Line
                                                                                    type="monotone"
                                                                                    dataKey="total_pf"
                                                                                    name="Total Power Factor"
                                                                                    stroke={darkMode ? colors.g2 : colors.g10}
                                                                                    strokeWidth={2}
                                                                                    dot={false}
                                                                                    connectNulls
                                                                                />

                                                                                <Area
                                                                                    type="monotone"
                                                                                    dataKey="low_pf"
                                                                                    fill="red"
                                                                                    stroke="red"
                                                                                    fillOpacity={0.3}
                                                                                    connectNulls={false}
                                                                                />

                                                                                <Brush
                                                                                    dataKey="recorded_at"
                                                                                    height={20}
                                                                                    stroke={darkMode ? colors.g4 : '#8884d8'}
                                                                                    travellerWidth={10}
                                                                                    tickFormatter={(tick) => moment(tick).format('HH:mm')}
                                                                                />
                                                                            </LineChart>
                                                                        </ResponsiveContainer>
                                                                    ) : (
                                                                        <Typography align="center" color="text.secondary">
                                                                            No Power Factor data.
                                                                        </Typography>
                                                                    )}
                                                                </Box>}

                                                            {/* Solar Apparent Power Graph */}
                                                            {graphToggles?.apparent_power &&
                                                                <Box sx={{ width: '48%', height: 350, mb: 6 }}>
                                                                    <Typography
                                                                        variant="subtitle1"
                                                                        sx={{
                                                                            mb: 1,
                                                                            fontWeight: 600,
                                                                            textAlign: 'center',
                                                                            color: darkMode ? colors.f2 : colors.f3
                                                                        }}
                                                                    >
                                                                        Apparent Power
                                                                    </Typography>
                                                                    {solarPowerKVAData?.length > 0 ? (
                                                                        <ResponsiveContainer width="100%" height="100%">
                                                                            <LineChart data={solarPowerKVAData}>
                                                                                <CartesianGrid strokeDasharray="3 3" />

                                                                                <XAxis
                                                                                    dataKey="recorded_at"
                                                                                    ticks={meterKVATicks}
                                                                                    interval={0}
                                                                                    tickFormatter={(tick) => moment(tick).format('HH:mm')}
                                                                                    tick={{ fontSize: 12, fill: darkMode ? colors.f2 : colors.f3 }}
                                                                                    angle={-65}
                                                                                    textAnchor="end"
                                                                                    height={60}
                                                                                />

                                                                                <YAxis
                                                                                    tickFormatter={(value) => value.toFixed(2)}
                                                                                    label={{
                                                                                        value: 'Apparent Power',
                                                                                        angle: -90,
                                                                                        position: 'insideLeft',
                                                                                        style: { fontSize: '0.6vw' },
                                                                                    }}
                                                                                    tick={{ fontSize: 12, fill: darkMode ? colors.f2 : colors.f3 }}
                                                                                />

                                                                                <Tooltip
                                                                                    formatter={(value) => [Number(value).toFixed(2), ' Apparent Power']}
                                                                                    labelFormatter={(label) =>
                                                                                        `Time: ${moment(label).format('DD-MM-YYYY HH:mm')} `
                                                                                    }
                                                                                    contentStyle={{
                                                                                        backgroundColor: darkMode
                                                                                            ? 'rgba(0, 0, 25, 0.8)'
                                                                                            : colors.f2,
                                                                                        color: darkMode ? colors.f2 : colors.f3,
                                                                                    }}
                                                                                />

                                                                                <Legend
                                                                                    verticalAlign="bottom"
                                                                                    height={36}
                                                                                />

                                                                                <Line
                                                                                    type="monotone"
                                                                                    dataKey="total_apparent_power_kva"
                                                                                    name=" Apparent Power"
                                                                                    stroke={darkMode ? colors.g2 : colors.g10}
                                                                                    strokeWidth={2}
                                                                                    dot={false}
                                                                                    connectNulls
                                                                                />

                                                                                <Brush
                                                                                    dataKey="recorded_at"
                                                                                    height={20}
                                                                                    stroke={darkMode ? colors.g4 : '#8884d8'}
                                                                                    travellerWidth={10}
                                                                                    tickFormatter={(tick) => moment(tick).format('HH:mm')}
                                                                                />
                                                                            </LineChart>
                                                                        </ResponsiveContainer>
                                                                    ) : (
                                                                        <Typography align="center" color="text.secondary">
                                                                            No Apparent Power data.
                                                                        </Typography>
                                                                    )}
                                                                </Box>}

                                                            {/* Voltage Harmonics Graph */}
                                                            {graphToggles?.voltage_harmonics && hasHarmonicsData(processedHarmonicsVoltage, ['harmonic_voltage_rate_a', 'harmonic_voltage_rate_b', 'harmonic_voltage_rate_c']) && (
                                                                <Box sx={{ width: '48%', height: 350, mb: 6 }}>
                                                                    <Typography
                                                                        variant="subtitle1"
                                                                        sx={{
                                                                            mb: 1,
                                                                            fontWeight: 600,
                                                                            textAlign: 'center',
                                                                            color: darkMode ? colors.f2 : colors.f3
                                                                        }}
                                                                    >
                                                                        Voltage Harmonics (%)
                                                                    </Typography>
                                                                    {processedHarmonicsVoltage?.length > 0 ? (
                                                                        <ResponsiveContainer width="100%" height="100%">
                                                                            <ComposedChart data={processedHarmonicsVoltage}>
                                                                                <CartesianGrid strokeDasharray="3 3" />

                                                                                <XAxis
                                                                                    dataKey="recorded_at"
                                                                                    ticks={meterHarmonicsVoltageTicks}
                                                                                    interval={0}
                                                                                    tickFormatter={(tick) => moment(tick).format('HH:mm')}
                                                                                    tick={{ fontSize: 12, fill: darkMode ? colors.f2 : colors.f3 }}
                                                                                    angle={-65}
                                                                                    textAnchor="end"
                                                                                    height={60}
                                                                                />

                                                                                <YAxis
                                                                                    tickFormatter={(value) => value.toFixed(2)}
                                                                                    label={{
                                                                                        value: 'THD (%)',
                                                                                        angle: -90,
                                                                                        position: 'insideLeft',
                                                                                        style: { fontSize: '0.6vw' },
                                                                                    }}
                                                                                    tick={{ fontSize: 12, fill: darkMode ? colors.f2 : colors.f3 }}
                                                                                />

                                                                                <Tooltip
                                                                                    formatter={(value, name) => [Number(value).toFixed(2), name]}
                                                                                    labelFormatter={(label) => `Time: ${moment(label).format('DD-MM-YYYY HH:mm')} `}
                                                                                />

                                                                                <Legend
                                                                                    verticalAlign="bottom"
                                                                                    height={36}
                                                                                    wrapperStyle={{ fontSize: '0.7vw' }}
                                                                                    onClick={(e) => SM_handleLegendClick(meter.serial_number, e.dataKey)}
                                                                                />

                                                                                <Line
                                                                                    type="monotone"
                                                                                    dataKey="harmonic_voltage_rate_a"
                                                                                    name="Voltage Harmonics A (%)"
                                                                                    stroke="#ff7300"
                                                                                    strokeWidth={2}
                                                                                    dot={false}
                                                                                    connectNulls
                                                                                    opacity={meterVisibility.harmonic_voltage_rate_a === false ? 0 : 1}
                                                                                />
                                                                                <Line
                                                                                    type="monotone"
                                                                                    dataKey="harmonic_voltage_rate_b"
                                                                                    name="Voltage Harmonics B (%)"
                                                                                    stroke="#ffc658"
                                                                                    strokeWidth={2}
                                                                                    dot={false}
                                                                                    connectNulls
                                                                                    opacity={meterVisibility.harmonic_voltage_rate_b === false ? 0 : 1}
                                                                                />
                                                                                <Line
                                                                                    type="monotone"
                                                                                    dataKey="harmonic_voltage_rate_c"
                                                                                    name="Voltage Harmonics C (%)"
                                                                                    stroke="#6394cc"
                                                                                    strokeWidth={2}
                                                                                    dot={false}
                                                                                    connectNulls
                                                                                    opacity={meterVisibility.harmonic_voltage_rate_c === false ? 0 : 1}
                                                                                />

                                                                                <Brush
                                                                                    dataKey="recorded_at"
                                                                                    height={20}
                                                                                    stroke={darkMode ? colors.g4 : '#8884d8'}
                                                                                    travellerWidth={10}
                                                                                    tickFormatter={(tick) => moment(tick).format('HH:mm')}
                                                                                />
                                                                            </ComposedChart>
                                                                        </ResponsiveContainer>
                                                                    ) : (
                                                                        <Typography align="center" color="text.secondary">
                                                                            No Voltage Harmonics data.
                                                                        </Typography>
                                                                    )}
                                                                </Box>
                                                            )}

                                                            {/* Current Harmonics Graph */}
                                                            {graphToggles?.current_harmonics && hasHarmonicsData(processedHarmonicsCurrent, ['harmonic_current_rate_a', 'harmonic_current_rate_b', 'harmonic_current_rate_c']) && (
                                                                <Box sx={{ width: '48%', height: 350, mb: 6 }}>
                                                                    <Typography
                                                                        variant="subtitle1"
                                                                        sx={{
                                                                            mb: 1,
                                                                            fontWeight: 600,
                                                                            textAlign: 'center',
                                                                            color: darkMode ? colors.f2 : colors.f3
                                                                        }}
                                                                    >
                                                                        Current Harmonics (%)
                                                                    </Typography>
                                                                    {processedHarmonicsCurrent?.length > 0 ? (
                                                                        <ResponsiveContainer width="100%" height="100%">
                                                                            <ComposedChart data={processedHarmonicsCurrent}>
                                                                                <CartesianGrid strokeDasharray="3 3" />

                                                                                <XAxis
                                                                                    dataKey="recorded_at"
                                                                                    ticks={meterHarmonicsCurrentTicks}
                                                                                    interval={0}
                                                                                    tickFormatter={(tick) => moment(tick).format('HH:mm')}
                                                                                    tick={{ fontSize: 12, fill: darkMode ? colors.f2 : colors.f3 }}
                                                                                    angle={-65}
                                                                                    textAnchor="end"
                                                                                    height={60}
                                                                                />

                                                                                <YAxis
                                                                                    tickFormatter={(value) => value.toFixed(2)}
                                                                                    label={{
                                                                                        value: 'THD (%)',
                                                                                        angle: -90,
                                                                                        position: 'insideLeft',
                                                                                        style: { fontSize: '0.6vw' },
                                                                                    }}
                                                                                    tick={{ fontSize: 12, fill: darkMode ? colors.f2 : colors.f3 }}
                                                                                />

                                                                                <Tooltip
                                                                                    formatter={(value, name) => [Number(value).toFixed(2), name]}
                                                                                    labelFormatter={(label) => `Time: ${moment(label).format('DD-MM-YYYY HH:mm')} `}
                                                                                />

                                                                                <Legend
                                                                                    verticalAlign="bottom"
                                                                                    height={36}
                                                                                    wrapperStyle={{ fontSize: '0.7vw' }}
                                                                                    onClick={(e) => SM_handleLegendClick(meter.serial_number, e.dataKey)}
                                                                                />

                                                                                <Line
                                                                                    type="monotone"
                                                                                    dataKey="harmonic_current_rate_a"
                                                                                    name="Current Harmonics A (%)"
                                                                                    stroke="#ff7300"
                                                                                    strokeWidth={2}
                                                                                    dot={false}
                                                                                    connectNulls
                                                                                    opacity={meterVisibility.harmonic_current_rate_a === false ? 0 : 1}
                                                                                />
                                                                                <Line
                                                                                    type="monotone"
                                                                                    dataKey="harmonic_current_rate_b"
                                                                                    name="Current Harmonics B (%)"
                                                                                    stroke="#ffc658"
                                                                                    strokeWidth={2}
                                                                                    dot={false}
                                                                                    connectNulls
                                                                                    opacity={meterVisibility.harmonic_current_rate_b === false ? 0 : 1}
                                                                                />
                                                                                <Line
                                                                                    type="monotone"
                                                                                    dataKey="harmonic_current_rate_c"
                                                                                    name="Current Harmonics C (%)"
                                                                                    stroke="#6394cc"
                                                                                    strokeWidth={2}
                                                                                    dot={false}
                                                                                    connectNulls
                                                                                    opacity={meterVisibility.harmonic_current_rate_c === false ? 0 : 1}
                                                                                />

                                                                                <Brush
                                                                                    dataKey="recorded_at"
                                                                                    height={20}
                                                                                    stroke={darkMode ? colors.g4 : '#8884d8'}
                                                                                    travellerWidth={10}
                                                                                    tickFormatter={(tick) => moment(tick).format('HH:mm')}
                                                                                />
                                                                            </ComposedChart>
                                                                        </ResponsiveContainer>
                                                                    ) : (
                                                                        <Typography align="center" color="text.secondary">
                                                                            No Current Harmonics data.
                                                                        </Typography>
                                                                    )}
                                                                </Box>
                                                            )}

                                                            {/* Building Load Percentage Graph */}
                                                            {graphToggles?.building_load &&
                                                                <Box sx={{ width: '48%', height: 350, mb: 6, }}>
                                                                    <Typography
                                                                        variant="subtitle1"
                                                                        sx={{
                                                                            mb: 1,
                                                                            fontWeight: 600,
                                                                            textAlign: 'center',
                                                                            color: darkMode ? colors.f2 : colors.f3
                                                                        }}
                                                                    >
                                                                        Building Load Percentage
                                                                    </Typography>

                                                                    {meter.percentage_graph && meter.percentage_graph.length > 0 ? (
                                                                        <ResponsiveContainer width="100%" height="100%">
                                                                            <LineChart data={meter.percentage_graph}>  {/* Use raw data directly */}
                                                                                <CartesianGrid strokeDasharray="3 3" />

                                                                                <XAxis
                                                                                    dataKey="recorded_at"
                                                                                    ticks={solarTicks}
                                                                                    interval={0}
                                                                                    tickFormatter={(tick) => moment(tick).format('HH:mm')}
                                                                                    tick={{ fontSize: 12, fill: darkMode ? colors.f2 : colors.f3 }}
                                                                                    angle={-65}
                                                                                    textAnchor="end"
                                                                                    height={60}
                                                                                />

                                                                                <YAxis
                                                                                    domain={[0, 100]}  // Percentage is 0-100
                                                                                    tickFormatter={(value) => {
                                                                                        // Format to 2 decimal places, but trim trailing .00
                                                                                        const formatted = Number(value).toFixed(2);
                                                                                        const trimmed = formatted.replace(/\.00$/, '');
                                                                                        return `${trimmed}% `;
                                                                                    }}
                                                                                    label={{
                                                                                        value: 'Percentage (%)',
                                                                                        angle: -90,
                                                                                        position: 'insideLeft',
                                                                                        style: { fontSize: '0.6vw' },
                                                                                    }}
                                                                                    tick={{ fontSize: 12, fill: darkMode ? colors.f2 : colors.f3 }}
                                                                                />

                                                                                <Tooltip
                                                                                    formatter={(value) => [`${Number(value).toFixed(2)}% `, 'Building Load']}
                                                                                    labelFormatter={(label) => `Time: ${moment(label).format('DD-MM-YYYY HH:mm')} `}
                                                                                />

                                                                                <Legend verticalAlign="bottom" height={36} />

                                                                                <Line
                                                                                    type="monotone"
                                                                                    dataKey="percentage"  // Use the percentage field from your data
                                                                                    name="Building Load Percentage"
                                                                                    stroke={darkMode ? colors.g1 : colors.g10}
                                                                                    strokeWidth={2}
                                                                                    dot={false}
                                                                                    connectNulls
                                                                                />

                                                                                <Brush
                                                                                    dataKey="recorded_at"
                                                                                    height={20}
                                                                                    stroke={darkMode ? colors.g4 : '#8884d8'}
                                                                                    travellerWidth={10}
                                                                                    tickFormatter={(tick) => moment(tick).format('HH:mm')}
                                                                                />
                                                                            </LineChart>
                                                                        </ResponsiveContainer>
                                                                    ) : (
                                                                        <Typography align="center" color="text.secondary">
                                                                            No Percentage data available.
                                                                        </Typography>
                                                                    )}
                                                                </Box>}

                                                        </Box>
                                                    </Box>
                                                </React.Fragment>
                                            );
                                        })}
                                    </Box>
                                )}
                            </Box>
                        ) : (
                            ""
                        )}
                    </div>

                </Box>

            ) : (
                <Box sx={{ '& > *': { mb: "5rem" }, backgroundColor: darkMode ? 'rgba(255,255,255,0.1)' : colors.l7, borderRadius: "20px", paddingBottom: "10px", paddingTop: "20px" }}>
                    {/* Grid,Load & Solar Analysis */}
                    <Box display="flex" justifyContent="center">
                        <Box sx={{ width: '70%', height: { xs: 300, md: 500 } }}>
                            <Typography sx={{ mb: 2, textAlign: 'center', color: darkMode ? colors.f2 : colors.f3, fontSize: '1.5rem', fontWeight: 'bold' }}>
                                Grid, Load & Solar Generation Analysis
                            </Typography>
                            <ResponsiveContainer width="100%" height="100%">
                                <LineChart
                                    data={createChartData(
                                        [gridWithEcosData, BuildingLoad, solarData],
                                        ['grid_value', 'building_load', 'solar_value']
                                    )}
                                >
                                    <CartesianGrid strokeDasharray="3 3" stroke={darkMode ? colors.f2 : colors.f1} />
                                    <XAxis dataKey="timestamp" interval="preserveStartEnd" type="category" tick={{ fontSize: 12, fill: darkMode ? colors.f2 : colors.f3 }}
                                        tickFormatter={(tick) => moment(tick).format('HH:mm')} />
                                    <YAxis tick={{ fontSize: 12, fill: darkMode ? colors.f2 : colors.f3 }} label={{ value: 'Power (kW)', angle: -90, position: 'insideLeft', offset: 10, fill: darkMode ? colors.f2 : colors.f3 }} />
                                    <Tooltip formatter={(value, name) => [value.toFixed(2), name]} labelFormatter={(label) => { const formattedDate = moment(label).format('DD-MM-YYYY HH:mm'); return `Time: ${formattedDate} `; }}
                                        contentStyle={{
                                            backgroundColor: darkMode ? 'rgba(0,0, 25,0.8)' : colors.f2,
                                            color: darkMode ? colors.f2 : colors.f3,
                                        }} />
                                    <Legend
                                        onClick={(props) => handleLegendClick(props.dataKey)}
                                    />
                                    {[
                                        { dataKey: 'grid_value', color: darkMode ? colors.g3 : colors.g1, name: 'Incoming Grid' },
                                        { dataKey: 'building_load', color: darkMode ? colors.g4 : colors.g11, name: 'Building Load' },
                                        { dataKey: 'solar_value', color: darkMode ? colors.g2 : colors.g10, name: 'Solar Generation' },
                                    ]
                                        .map(({ dataKey, color, name }) => (
                                            <Line key={dataKey} type="monotone" connectNulls={true} dataKey={dataKey} stroke={color} strokeWidth={2} dot={{ r: 2, fill: color }} animationDuration={1000} name={name} hide={activeSeries.includes(dataKey)} />
                                        ))}
                                </LineChart>
                            </ResponsiveContainer>
                        </Box>
                    </Box>
                    {/* Grid Consumption Analysis */}
                    <Box display="flex" justifyContent="center">
                        <Box sx={{ width: '70%', height: { xs: 300, md: 500 } }}>
                            <Typography sx={{ mb: 2, textAlign: 'center', color: darkMode ? colors.f2 : colors.f3, fontSize: '1.5rem', fontWeight: 'bold' }}>
                                Grid Consumption Analysis
                            </Typography>
                            <ResponsiveContainer width="100%" height="100%">
                                <LineChart
                                    data={createChartData(
                                        [gridWithoutEcosData, gridWithEcosData],
                                        ['grid_with_solar', 'grid_value']
                                    )}>
                                    <CartesianGrid strokeDasharray="3 3" stroke={darkMode ? colors.f2 : colors.f1} />
                                    <XAxis dataKey="timestamp" interval="preserveStartEnd" type="category" tickFormatter={(tick) => moment(tick).format('HH:mm')} tick={{ fontSize: 12, fill: darkMode ? colors.f2 : colors.f3 }} />
                                    <YAxis tick={{ fontSize: 12, fill: darkMode ? colors.f2 : colors.f3 }} label={{ value: 'Power (kW)', angle: -90, position: 'insideLeft', offset: 10, fill: darkMode ? colors.f2 : colors.f3 }} />
                                    <Tooltip formatter={(value, name) => [value.toFixed(2), name]} labelFormatter={(label) => { const formattedDate = moment(label).format('DD-MM-YYYY HH:mm'); return `Time: ${formattedDate} `; }}
                                        contentStyle={{
                                            backgroundColor: darkMode ? 'rgba(0,0, 25,0.8)' : colors.f2,
                                            color: darkMode ? colors.f2 : colors.f3,
                                        }} />
                                    <Legend
                                        onClick={(props) => handleLegendClick(props.dataKey)}
                                    />
                                    {[
                                        { dataKey: 'grid_value', color: darkMode ? colors.g1 : colors.g4, name: 'Grid After ECOS' },
                                        { dataKey: 'grid_with_solar', color: darkMode ? colors.g2 : colors.g1, name: 'Grid Before ECOS' },
                                    ]
                                        .map(({ dataKey, color, name }) => (
                                            <Line key={dataKey} type="monotone" dataKey={dataKey} connectNulls={true} stroke={color} strokeWidth={2} dot={{ r: 2, fill: color }} animationDuration={1000} name={name} hide={activeSeries.includes(dataKey)} />

                                        ))}
                                </LineChart>
                            </ResponsiveContainer>
                        </Box>
                    </Box>

                    {/* Battery Performance Analysis */}
                    <Box display="flex" justifyContent="center">
                        <Box sx={{ width: '70%', height: { xs: 300, md: 500 } }}>
                            <Typography sx={{ mb: 2, textAlign: 'center', color: darkMode ? colors.f2 : colors.f3, fontSize: '1.5rem', fontWeight: 'bold' }}>
                                Battery Performance Analysis
                            </Typography>
                            <ResponsiveContainer width="100%" height="100%">
                                <ComposedChart
                                    data={createChartData([batteryPowerData, batterySOCData], ['battery_power', 'battery_soc_value'])}
                                >
                                    <CartesianGrid strokeDasharray="3 3" stroke={darkMode ? colors.f2 : colors.f1} />
                                    {/* X-axis */}
                                    <XAxis
                                        dataKey="timestamp"
                                        interval="preserveStartEnd"
                                        type="category"
                                        tickFormatter={(tick) => moment(tick).format('HH:mm')}
                                        tick={{ fontSize: 12, fill: darkMode ? colors.f2 : colors.f3 }}
                                    />

                                    {/* Left Y-axis (Battery Power) */}
                                    <YAxis
                                        yAxisId="left"
                                        tick={{ fontSize: 12, fill: darkMode ? colors.f2 : colors.f3 }}
                                        label={{
                                            value: 'Power (kW)',
                                            angle: -90,
                                            position: 'insideLeft',
                                            offset: 10,
                                            fill: darkMode ? colors.f2 : colors.f3,
                                        }}
                                    />

                                    {/* Right Y-axis (Battery SOC %) */}
                                    <YAxis
                                        yAxisId="right"
                                        orientation="right"
                                        domain={[0, 100]}
                                        tick={{ fill: darkMode ? colors.f2 : colors.f3 }}
                                        label={{
                                            value: 'SOC (%)',
                                            angle: -90,
                                            position: 'insideRight',
                                            offset: 10,
                                            fill: darkMode ? colors.f2 : colors.f3,
                                        }}
                                    />

                                    {/* Tooltip */}
                                    <Tooltip
                                        formatter={(value, name) => [value.toFixed(2), name]}
                                        labelFormatter={(label) => `Time: ${moment(label).format('DD-MM-YYYY HH:mm')} `}
                                        contentStyle={{
                                            backgroundColor: darkMode ? 'rgba(0,0,25,0.8)' : colors.f2,
                                            color: darkMode ? colors.f2 : colors.f3,
                                        }}
                                    />

                                    {/* Legend */}
                                    <Legend onClick={(props) => handleLegendClick(props.dataKey)} />

                                    {/* Area for Battery SOC */}
                                    <Area
                                        yAxisId="right"
                                        dataKey="battery_soc_value"
                                        name="Battery SOC (%)"
                                        fill={darkMode ? colors.g4 : colors.g13}
                                        stroke={darkMode ? colors.g4 : colors.g13}
                                        strokeWidth={3}
                                        connectNulls
                                        animationDuration={1000}
                                        fillOpacity={0.4} // Make the area behind the line semi-transparent
                                        hide={activeSeries.includes('battery_soc_value')}
                                    />
                                    {/* Line for Battery Power */}
                                    <Line
                                        yAxisId="left"
                                        type="monotone"
                                        connectNulls
                                        dataKey="battery_power"
                                        stroke={darkMode ? colors.g1 : colors.g9}
                                        strokeWidth={3}
                                        dot={{ r: 2, fill: darkMode ? colors.g3 : colors.g9 }}
                                        animationDuration={1000}
                                        name="Battery Power (kW)"
                                        hide={activeSeries.includes('battery_power')}
                                    />
                                </ComposedChart>
                            </ResponsiveContainer>
                        </Box>
                    </Box>


                    {/* Load Forecast Analysis */}
                    <Box display="flex" justifyContent="center">
                        <Box sx={{ width: '70%', height: { xs: 300, md: 500 } }}>
                            <Typography sx={{ mb: 2, textAlign: 'center', color: darkMode ? colors.f2 : colors.f3, fontSize: '1.5rem', fontWeight: 'bold' }}>
                                Load Forecast Analysis
                            </Typography>
                            <ResponsiveContainer width="100%" height="100%">
                                <LineChart
                                    data={forecastcreateChartData(
                                        [loadForecastData, BuildingLoad],
                                        ['forecast_load_value', 'building_load']
                                    )}
                                >
                                    <CartesianGrid strokeDasharray="3 3" stroke={darkMode ? colors.f2 : colors.f1} />
                                    <XAxis dataKey="timestamp" interval="preserveStartEnd" type="category" tickFormatter={(tick) => moment(tick).format('HH:mm')} tick={{ fontSize: 12, fill: darkMode ? colors.f2 : colors.f3 }} />
                                    <YAxis tick={{ fontSize: 12, fill: darkMode ? colors.f2 : colors.f3 }} label={{ value: 'Power (kW)', angle: -90, position: 'insideLeft', offset: 10, fill: darkMode ? colors.f2 : colors.f3 }} />
                                    <Tooltip formatter={(value, name) => [value.toFixed(2), name]} labelFormatter={(label) => { const formattedDate = moment(label).format('DD-MM-YYYY HH:mm'); return `Time: ${formattedDate} `; }}
                                        contentStyle={{
                                            backgroundColor: darkMode ? 'rgba(0,0, 25,0.8)' : colors.f2,
                                            color: darkMode ? colors.f2 : colors.f3,
                                        }} />

                                    <Legend
                                        onClick={(props) => handleLegendClick(props.dataKey)}
                                    />
                                    {[
                                        { dataKey: 'forecast_load_value', color: darkMode ? colors.g2 : colors.f4, name: 'Load Forecast' },
                                        { dataKey: 'building_load', color: darkMode ? colors.g3 : colors.g11, name: 'Actual Load' },
                                    ].map(({ dataKey, color, name }) => (
                                        <Line key={dataKey} type="monotone" connectNulls={true} dataKey={dataKey} stroke={color} strokeWidth={2} dot={{ r: 2, fill: color }} animationDuration={1000} name={name} hide={activeSeries.includes(dataKey)} />
                                    ))}
                                </LineChart>
                            </ResponsiveContainer>
                        </Box>
                    </Box>

                    {/* Solar Forecast Analysis */}
                    <Box display="flex" justifyContent="center">
                        <Box sx={{ width: '70%', height: { xs: 300, md: 500 } }}>
                            <Typography sx={{ mb: 2, textAlign: 'center', color: darkMode ? colors.f2 : colors.f3, fontSize: '1.5rem', fontWeight: 'bold' }}>
                                Solar Forecast Analysis
                            </Typography>
                            <ResponsiveContainer width="100%" height="100%">
                                <LineChart
                                    data={forecastcreateChartData(
                                        [solarForecastData, solarData],
                                        ['forecast_solar_value', 'solar_value']
                                    )}
                                >
                                    <CartesianGrid strokeDasharray="3 3" stroke={darkMode ? colors.f2 : colors.f1} />
                                    <XAxis dataKey="timestamp" interval="preserveStartEnd" type="category" tickFormatter={(tick) => moment(tick).format('HH:mm')} tick={{ fontSize: 12, fill: darkMode ? colors.f2 : colors.f3 }} />
                                    <YAxis tick={{ fontSize: 12, fill: darkMode ? colors.f2 : colors.f3 }} label={{ value: 'Power (kW)', angle: -90, position: 'insideLeft', offset: 10, fill: darkMode ? colors.f2 : colors.f3 }} />
                                    <Tooltip formatter={(value, name) => [value.toFixed(2), name]} labelFormatter={(label) => { const formattedDate = moment(label).format('DD-MM-YYYY HH:mm'); return `Time: ${formattedDate} `; }}
                                        contentStyle={{
                                            backgroundColor: darkMode ? 'rgba(0,0, 25,0.8)' : colors.f2,
                                            color: darkMode ? colors.f2 : colors.f3,
                                        }} />

                                    <Legend
                                        onClick={(props) => handleLegendClick(props.dataKey)}
                                    />
                                    {[
                                        { dataKey: 'forecast_solar_value', color: darkMode ? colors.g3 : colors.g2, name: 'Solar Forecast' },
                                        { dataKey: 'solar_value', color: darkMode ? colors.g2 : colors.g10, name: 'Actual Solar' },
                                    ].map(({ dataKey, color, name }) => (
                                        <Line key={dataKey} type="monotone" dataKey={dataKey} stroke={color} connectNulls={true} strokeWidth={2} dot={{ r: 2, fill: color }} animationDuration={1000} name={name} hide={activeSeries.includes(dataKey)} />
                                    ))}
                                </LineChart>
                            </ResponsiveContainer>
                        </Box>
                    </Box>
                </Box>
            )}
        </>
    );
};



export default GraphSection;
